// AUTO-GENERATED by scripts/generate-updates.cjs on every build — DO NOT EDIT.
// One entry per commit since the curated boundary. Curated history lives in updatesData.ts.
import type { UpdateEntry } from './updatesData'

export const GENERATED_UPDATES: UpdateEntry[] = [
  {
    "date": "2026-11-03",
    "title": "Tasks from meetings switched off: Gemini next steps become an activity note, follow-up …",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Tasks from meetings switched off: Gemini next steps become an activity note, follow-up sends create no tasks (env-gated MEETING_NOTES_TASKS=1 to restore) — Lee, 3 Nov 2026."
    ]
  },
  {
    "date": "2026-11-03",
    "title": "Framer intake: flat-payload support with field aliases + kind-in-URL variant for Framer…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Framer intake: flat-payload support with field aliases + kind-in-URL variant for Framer's built-in webhook, and CORS on the endpoint for direct page submits (Lee, 3 Nov 2026)."
    ]
  },
  {
    "date": "2026-11-03",
    "title": "Framer intake: flat-payload support with field aliases + kind-in-URL variant for Framer…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Framer intake: flat-payload support with field aliases + kind-in-URL variant for Framer's built-in webhook, and CORS on the endpoint for direct page submits (Lee, 3 Nov 2026)."
    ]
  },
  {
    "date": "2026-11-03",
    "title": "Cancellation events per Robert's release: withdrawal Slack post + bell, timestamp-order…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Cancellation events per Robert's release: withdrawal Slack post + bell, timestamp-ordering guard against stale pending events, requested_at/requested_by honoured, repeat-request quiet refresh (Lee, 3 Nov 2026)."
    ]
  },
  {
    "date": "2026-11-03",
    "title": "Website forms intake (Framer): /api/webhooks/framer endpoint, form submissions store, R…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Website forms intake (Framer): /api/webhooks/framer endpoint, form submissions store, REQUESTED + DEMO BOOKING PENDING badges, Price Enquired stage/columns/Contract-Manager tab, lead facts rail as accordions with Form submissions panel, Calendly link-up (Lee, 3 Nov 2026)."
    ]
  },
  {
    "date": "2026-11-02",
    "title": "CRM: Archive surfaced — button next to Mark Won/Lost on the lead screen and hover contr…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "CRM: Archive surfaced — button next to Mark Won/Lost on the lead screen and hover control on board cards, with Unarchive for archived leads (Lee, 2 Nov 2026)."
    ]
  },
  {
    "date": "2026-11-02",
    "title": "Onboarding to-dos: derived rows (reply/book/follow-up/plan/file) default to Natalie Low…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding to-dos: derived rows (reply/book/follow-up/plan/file) default to Natalie Lowe instead of Unassigned (Lee, 2 Nov 2026)."
    ]
  },
  {
    "date": "2026-11-02",
    "title": "Onboarding tasks: our-side tasks on onboarded leads default to Natalie Lowe when no own…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding tasks: our-side tasks on onboarded leads default to Natalie Lowe when no owner is named (Lee, 2 Nov 2026)."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Contracts: unassigned-lead fallback for signed/executed emails — Andy + wequote@ + info…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contracts: unassigned-lead fallback for signed/executed emails — Andy + wequote@ + info@ get copies when the lead has no owner (the Custom Sight & Sound miss); audit records sentTo."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings UI sweep: live components framed in module cards, row-divider property-orde…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings UI sweep: live components framed in module cards, row-divider property-order bug fixed, mockup hover states shipped, calendar min-width."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings: fixed chrome + scrolling lists on every module screen — company page tabs,…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: fixed chrome + scrolling lists on every module screen — company page tabs, full-height board columns with internal card scroll, to-do table, follow-ups panes, calendar grid, analytics content."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings UI polish: full-width layouts, short Locked labels with tooltips, clamped t…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings UI polish: full-width layouts, short Locked labels with tooltips, clamped text, tidy to-do rows, SVG icons instead of emojis."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings design rebuild 3/3: Board, To-do, Follow-ups, Session calendar and Analytic…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings design rebuild 3/3: Board, To-do, Follow-ups, Session calendar and Analytics matched to the handover mockups (DropMenu/SegToggle primitives, mockup tiles/tabs/tables/cards)."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings design rebuild 2/3: To-do, Sessions, Notes, Emails & chats, Plan & payments…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Onboardings design rebuild 2/3: To-do, Sessions, Notes, Emails & chats, Plan & payments and Details tabs matched to the handover mockups; task PATCH gains dueAt/ownerName for Extend/Assign."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings design rebuild 1/3: company page + Pathways matched to the handover mockups…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings design rebuild 1/3: company page + Pathways matched to the handover mockups (obDesign system, Journey + Checklist views, Company.dc Overview + chrome + plan strip)."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings Phases 3-5 (catch-up): board redesign, company page + lead summary tab, ses…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Onboardings Phases 3-5 (catch-up): board redesign, company page + lead summary tab, session calendar, analytics, API endpoints — completes the imports App.tsx already carried in 718's commit."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings Phase 2: Communication & follow-ups — wq_ob_drafts (migration 145), the 16 …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings Phase 2: Communication & follow-ups — wq_ob_drafts (migration 145), the 16 standard email templates, drafts service (8 types, status flow, required attachments, cc rule, suggested-tasks-on-send), per-mailbox sender, Follow-ups page, To-do integration."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings Phase 5: Session calendar (§2.16 week grid, tiles-as-filters, no-call list)…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings Phase 5: Session calendar (§2.16 week grid, tiles-as-filters, no-call list) + Analytics (§2.17 onboarding speed/usage + after-go-live health from anti-churn with draft actions); calendar + analytics API endpoints; new ensureDraft kinds."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Onboardings module Phase 1: task model (migration 144 — side/owner/pathway/station/sour…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Onboardings module Phase 1: task model (migration 144 — side/owner/pathway/station/source/chase clock), derived to-do engine (§3.2), Gemini action-item classifier (§3.1), new To-do page (§2.14) + nested sidebar item."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Cancellation pipeline: cancellation_requested banner (lead + card) + bell + Slack; canc…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Cancellation pipeline: cancellation_requested banner (lead + card) + bell + Slack; cancelled with status=cancellation_pending/effective_at → amber leaves-on banner + hourly self-flip sweep; plain cancelled → stage move + Slack; withdrawn event + staff dismiss. Migrations 142+143."
    ]
  },
  {
    "date": "2026-10-30",
    "title": "Lead screen redesign (signed-off mockup): journey bar with days-in-stage + Won/Lost, ch…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead screen redesign (signed-off mockup): journey bar with days-in-stage + Won/Lost, chrome-style tabs (Overview + 7 record tabs mounting the existing components), Overview with facts rail / pinned Next / composer / merged milestone timeline with filter chips; fixed viewport, only the feed scrolls. getDeal returns stageHistory; activities carry real timestamps."
    ]
  },
  {
    "date": "2026-10-29",
    "title": "Slack: deal-won full field set (region, billing frequency, contract length, MRR/ARR, ow…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Slack: deal-won full field set (region, billing frequency, contract length, MRR/ARR, owner initials, source) + 30-day dedupe; demo posts headed by Company (Person) with the real meet.google.com link resolved from Calendly proxies."
    ]
  },
  {
    "date": "2026-10-29",
    "title": "Slack deal-won: 30-day dedupe against stage history — flapping deals post once; a real …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Slack deal-won: 30-day dedupe against stage history — flapping deals post once; a real win-back after a month still announces."
    ]
  },
  {
    "date": "2026-10-29",
    "title": "Slack feeds: #new-client-demo (bookings + transcripts), #trials (new + re-signed trials…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Slack feeds: #new-client-demo (bookings + transcripts), #trials (new + re-signed trials), #deal-won (transition into live) via free incoming webhooks — inert until SLACK_WEBHOOK_* env vars are installed."
    ]
  },
  {
    "date": "2026-10-29",
    "title": "ADVISORY no longer catches confirmations/validations — those are PRODUCT_QUESTION (conf…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "ADVISORY no longer catches confirmations/validations — those are PRODUCT_QUESTION (confirm) or RESOLUTION, not a human hand-off"
    ]
  },
  {
    "date": "2026-10-28",
    "title": "visitor message avatar uses the company logo (neutral initial fallback); drop the loud …",
    "tags": [
      "Support"
    ],
    "bullets": [
      "visitor message avatar uses the company logo (neutral initial fallback); drop the loud generated name colour on live chats"
    ]
  },
  {
    "date": "2026-10-28",
    "title": "hide status/outcome tags that duplicate the status + AI-state badges on cards and chat …",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "hide status/outcome tags that duplicate the status + AI-state badges on cards and chat header"
    ]
  },
  {
    "date": "2026-10-28",
    "title": "visitor name on messages (not 'Customer'); emoji menu -> line icons; livelier avatars; …",
    "tags": [
      "Support"
    ],
    "bullets": [
      "visitor name on messages (not 'Customer'); emoji menu -> line icons; livelier avatars; higher-contrast chat cards"
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Alerts bell moves to the TopBar (next to Copilot, opens the lead); pending hours reques…",
    "tags": [
      "CRM",
      "Support",
      "AI"
    ],
    "bullets": [
      "Alerts bell moves to the TopBar (next to Copilot, opens the lead); pending hours requests visible on onboarding cards + as an actionable banner on the lead's Onboarding tab (audit-derived, cleared by topping up)."
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Onboardings: Pull-from-staging button removed (toolbar + empty state) — the 30-min auto…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: Pull-from-staging button removed (toolbar + empty state) — the 30-min auto-sync with watchdog covers it; server endpoint kept for script use."
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Onboarding hours request: popup with hours picker (1/2/4/8 chips or 1–100) + optional r…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding hours request: popup with hours picker (1/2/4/8 chips or 1–100) + optional reason + confirm; the staff alert and audit carry the requested hours and note."
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Onboarding hours: customer 'Request more hours' on every plan (raises an alert to us), …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding hours: customer 'Request more hours' on every plan (raises an alert to us), staff '+ Top up hours' button restored on the plan bar; the unqualified-demo red banner removed everywhere."
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Anti-churn: Snagg-only accounts (plan Snagg, £0 MRR) leave the cohort — Engineers-App-o…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Anti-churn: Snagg-only accounts (plan Snagg, £0 MRR) leave the cohort — Engineers-App-only users never quote and aren't in the usage feed; paying Snagg plans stay."
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Onboardings: Agreed Go-Live Date — prominent editable field at the top (staff), read-on…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: Agreed Go-Live Date — prominent editable field at the top (staff), read-only banner on the customer page, shown on board cards with year; staging sync stops seeding it from the activation date."
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Jesse resumes after any unanswered hand-off (AI_RESUME_SECONDS=20); fix ADVISORY miscla…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse resumes after any unanswered hand-off (AI_RESUME_SECONDS=20); fix ADVISORY misclassifying how-to/shortcut questions as judgment calls"
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Contract Studio tidy: sections 2/3/4 rebuilt with titled sub-panels — grouped price lis…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract Studio tidy: sections 2/3/4 rebuilt with titled sub-panels — grouped price lists, consistent rows, and SOW fields grouped to mirror the Part-B document with per-group progress."
    ]
  },
  {
    "date": "2026-10-28",
    "title": "Contract: additional hours payable 'Paid in advance for a set number of hours' (page/St…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract: additional hours payable 'Paid in advance for a set number of hours' (page/Studio/PDF); training what's-included restyled — eyebrow label + two-column tick list."
    ]
  },
  {
    "date": "2026-10-27",
    "title": "Contract Manager (Lee's notes): training what's-included everywhere incl. PDF + old-boo…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract Manager (Lee's notes): training what's-included everywhere incl. PDF + old-book hydration; Data Migration 100% on signing; additional hours only at £195/hr labelled Implementation & Training (stored day rates still honoured); scanner option £329 each with Studio count; SOW §2 shows only the selected training tier."
    ]
  },
  {
    "date": "2026-10-27",
    "title": "Call queue: archived + Trial Expired — Contacted leads stay out of the queue; a NEW fre…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Call queue: archived + Trial Expired — Contacted leads stay out of the queue; a NEW free-trial signup matching such a lead revives it (unarchive, stage back to On Trial on the board, auto_trial queue entry) via both the trial_started webhook and the bulk sync."
    ]
  },
  {
    "date": "2026-10-27",
    "title": "Anti-churn: At risk/Cooling judged on last quote TOUCH (last_quote_modified_at, request…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Anti-churn: At risk/Cooling judged on last quote TOUCH (last_quote_modified_at, requested from Robert) with created-date fallback until it ships; created date stays visible with a 'touched Nd ago' sub-line; ingest passes the field through."
    ]
  },
  {
    "date": "2026-10-27",
    "title": "Anti-Churn dash: 50 results per page (was 10); table scrolls, pagination for the rest.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Anti-Churn dash: 50 results per page (was 10); table scrolls, pagination for the rest."
    ]
  },
  {
    "date": "2026-10-27",
    "title": "Usage ingest: dedupe payload by account + per-row-tolerant inserts (a dup account id ab…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Usage ingest: dedupe payload by account + per-row-tolerant inserts (a dup account id aborted ingest after the first 200-row chunk daily since 25 Sept — Robert's finding), raw push archive for replay, pass last_quote_created_at/paid_addons through cleanEngagement; API volume: customer sync 2→10m, org-users 20→60m, onboarding key URL→Api-Key header."
    ]
  },
  {
    "date": "2026-10-27",
    "title": "My Day Today tab: send YYYY-MM-DD to /crm/bookings/mine (full ISO datetimes failed vali…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "My Day Today tab: send YYYY-MM-DD to /crm/bookings/mine (full ISO datetimes failed validation → silent empty day), fix demo/Google title field names, link Google events to their lead, trim the ±6h read padding to the local day."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Customer sync: twin-account guard — a free/supplier account sharing a contact email wit…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Customer sync: twin-account guard — a free/supplier account sharing a contact email with a paying account no longer overwrites the paying deal every cycle (the paid→free→paid flap behind the moving anti-churn count); paying accounts can rebind a deal stuck on its free twin."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Warmers staggered + serialised: 694's four background warmers fired in lockstep every 1…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Warmers staggered + serialised: 694's four background warmers fired in lockstep every 120s and stalled live requests — now one shared warm queue with 0/30/60/90s offsets, a gentle drip instead of a burst."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Always-warm caches: upgrade all five server memos to stale-while-revalidate (expired va…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Always-warm caches: upgrade all five server memos to stale-while-revalidate (expired values served instantly, recomputed in background) + 2-min background warmers on the four heavy summaries — returning to a page no longer pays the cold recompute."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "UI polish pass: global 150ms transitions + tactile press on all controls, modal fade-in…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "UI polish pass: global 150ms transitions + tactile press on all controls, modal fade-ins, side-panel glide, skeleton shimmer loaders replacing 'Loading…' text, tab crossfades on every hub, reduced-motion support."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Speed pass 2: gzip all API responses (~6MB/board-visit of JSON was shipping uncompresse…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Speed pass 2: gzip all API responses (~6MB/board-visit of JSON was shipping uncompressed), 60s single-flight memos on usage+support summaries (3.8s + 2.4s per board visit, unmemoised), cap listActivities at 500 (one deal held a connection 390s streaming its unlimited feed)."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Sidebar: Support + CRM groups always expanded — collapse toggle removed.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sidebar: Support + CRM groups always expanded — collapse toggle removed."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Speed pass: stale-while-revalidate on the CRM data hook (instant back-navigation) + 30s…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Speed pass: stale-while-revalidate on the CRM data hook (instant back-navigation) + 30s single-flight memos on the four full-table maps every deals request was re-running."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Pool relief: 60s single-flight memos on getAdoptionSummary + antiChurnPayload — stops t…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Pool relief: 60s single-flight memos on getAdoptionSummary + antiChurnPayload — stops the query storms that starved the DB pool (926 queued) and made clients fall back to stale cached counts."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Anti-Churn: Paying column shows billing terms (contract > T&Cs book > rolling-monthly d…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Anti-Churn: Paying column shows billing terms (contract > T&Cs book > rolling-monthly default) with tenure as the sub-line."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Anti-Churn: STALE FEED status for accounts WeQuote's push dropped on 25 Sept (evidence …",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Anti-Churn: STALE FEED status for accounts WeQuote's push dropped on 25 Sept (evidence brief for Robert included) — missing telemetry no longer reads as At Risk."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Anti-Churn: quotes-14d anchored on calendar windows near NOW, not the account's latest …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Anti-Churn: quotes-14d anchored on calendar windows near NOW, not the account's latest (stale) window — kills the 109-in-14d-but-quiet-33d contradiction."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Anti-Churn data fix: rolling 7-day windows read disjointly (no more ~5x quote counts), …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Anti-Churn data fix: rolling 7-day windows read disjointly (no more ~5x quote counts), suppliers excluded, honest approx labels."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "My Day ⇄ docks: To-dos tab shares the notebook store, attention panel embedded (double …",
    "tags": [
      "Widget"
    ],
    "bullets": [
      "My Day ⇄ docks: To-dos tab shares the notebook store, attention panel embedded (double bell fixed), docks hidden on My Day, Go-to-My-Day deep links on every dock."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "My Day: To-dos tab is a per-agent personal checklist (migration 141) — journey Task Das…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "My Day: To-dos tab is a per-agent personal checklist (migration 141) — journey Task Dashboard retired from the pane."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Companies merge into leads (step 1, migration 140): company fields backfilled onto deal…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Companies merge into leads (step 1, migration 140): company fields backfilled onto deals and exposed on the API; Companies/Contacts/Billing pages fold into Leads (billing as a tab); companies table frozen pending step-2 rewire."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "My Day (menu restructure phase B): Call Queue at the heart + Today schedule / Needs att…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "My Day (menu restructure phase B): Call Queue at the heart + Today schedule / Needs attention / To-dos tabs; replaces standalone Call Queue + Task Dashboard with redirects."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Menu restructure phase A: Board hub (Sales/Qualification/Analytics/Demos tabs), Shows+P…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Menu restructure phase A: Board hub (Sales/Qualification/Analytics/Demos tabs), Shows+Planner hub, Metrics Glossary as top-bar help popup, Lead Settings into Settings, Sequences removed, sidebar reordered with redirects."
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Save as PDF builds a transcript + opens the print dialog (works on active chats); old s…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Save as PDF builds a transcript + opens the print dialog (works on active chats); old server call was a no-op stub"
    ]
  },
  {
    "date": "2026-10-26",
    "title": "clean Chats hierarchy — shell owns title+tabs+toggle; views drop their own titles; remo…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "clean Chats hierarchy — shell owns title+tabs+toggle; views drop their own titles; remove tab-bar scrollbar"
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Contacts under Customers (tabs + per-company contacts); declutter chat badges; 'In WeQu…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Contacts under Customers (tabs + per-company contacts); declutter chat badges; 'In WeQuote now' visitor badge"
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Chats tabbed area (Active/Missed/Tickets/Resolution Notes) + shared 'My chats only' tog…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Chats tabbed area (Active/Missed/Tickets/Resolution Notes) + shared 'My chats only' toggle; remove separate sidebar items"
    ]
  },
  {
    "date": "2026-10-26",
    "title": "Dashboard page tabs — Dashboard | Chat History | Monthly Report | Complete; remove redu…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Dashboard page tabs — Dashboard | Chat History | Monthly Report | Complete; remove redundant History/Chat History sidebar items; redirect old routes"
    ]
  },
  {
    "date": "2026-10-26",
    "title": "remove standalone Analytics page + Knowledge Base page (routes, sidebar, command palett…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "remove standalone Analytics page + Knowledge Base page (routes, sidebar, command palette, dashboard link); keep AnalyticsDashboard component + article sharing + APIs"
    ]
  },
  {
    "date": "2026-10-23",
    "title": "Anti-Churn Dash replaces Customer Success: paid-book churn/expansion view per sandbox s…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Anti-Churn Dash replaces Customer Success: paid-book churn/expansion view per sandbox spec — KPI strip, status rules, gap-to-potential, module expansion, churn side panel with go-to-lead; live price book; Robert feed brief."
    ]
  },
  {
    "date": "2026-10-22",
    "title": "agent-set card title + message as description; persist title (migration 140)",
    "tags": [
      "Support"
    ],
    "bullets": [
      "agent-set card title + message as description; persist title (migration 140)"
    ]
  },
  {
    "date": "2026-10-22",
    "title": "chat/ticket feature requests now create a Needs Review card (shared createCardFromFeatu…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "chat/ticket feature requests now create a Needs Review card (shared createCardFromFeatureRequest helper + intake alert); modal copy updated"
    ]
  },
  {
    "date": "2026-10-22",
    "title": "ADVISORY handoff is one short canned line — no retrieval/model call, since a human give…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "ADVISORY handoff is one short canned line — no retrieval/model call, since a human gives the recommendation anyway (saves credits)"
    ]
  },
  {
    "date": "2026-10-22",
    "title": "ADVISORY routing — recommendation/best-approach/design-validation questions get the fac…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "ADVISORY routing — recommendation/best-approach/design-validation questions get the facts then a human handoff; plain how-tos stay with Jesse"
    ]
  },
  {
    "date": "2026-10-22",
    "title": "observability(db): log connection-pool usage every 30s + dump processlist when it climb…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "observability(db): log connection-pool usage every 30s + dump processlist when it climbs, to catch the pool-exhaustion cause"
    ]
  },
  {
    "date": "2026-10-21",
    "title": "never reveal sources/past-cases to the visitor; search long messages on distilled keywo…",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "never reveal sources/past-cases to the visitor; search long messages on distilled keywords alone (tasks/jobs was mis-retrieving payment stages)"
    ]
  },
  {
    "date": "2026-10-21",
    "title": "Meetings: harvest Meet recording + transcript links from calendar events onto bookings …",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Meetings: harvest Meet recording + transcript links from calendar events onto bookings (migration 139), link chips on the Meetings tab, sessions prefer the real transcript doc."
    ]
  },
  {
    "date": "2026-10-21",
    "title": "Lead matcher: test-named leads rank below any real lead — a shared contact email can no…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead matcher: test-named leads rank below any real lead — a shared contact email can no longer hijack meetings onto samtest (Crescent case)."
    ]
  },
  {
    "date": "2026-10-21",
    "title": "Meetings tab: source chip next to every status (Calendly demo / Calendar / CRM booking …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Meetings tab: source chip next to every status (Calendly demo / Calendar / CRM booking / CRM call) with hover explanations of Held vs Done vs Cancelled."
    ]
  },
  {
    "date": "2026-10-21",
    "title": "Board card meeting count: held Calendly demos included, cancelled meetings/demos exclud…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Board card meeting count: held Calendly demos included, cancelled meetings/demos excluded (Forrest Walker case)."
    ]
  },
  {
    "date": "2026-10-21",
    "title": "Meetings: past planned bookings auto-complete to done via the mirror (cancelled-on-Goog…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Meetings: past planned bookings auto-complete to done via the mirror (cancelled-on-Google still cancels) — no more eternal planned/overdue."
    ]
  },
  {
    "date": "2026-10-21",
    "title": "Phase 3 board cards: label/value contrast hierarchy, headline company name, touch strip…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Phase 3 board cards: label/value contrast hierarchy, headline company name, touch strip with calls+meetings counts and on-card Log call (both boards)."
    ]
  },
  {
    "date": "2026-10-21",
    "title": "Phase 1 call log: wq_crm_calls (migration 138, shaped for future auto call-tracking), l…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Phase 1 call log: wq_crm_calls (migration 138, shaped for future auto call-tracking), log-call modal with outcome chips, Activity-tab entry point, calls/meetings counts on the deals API."
    ]
  },
  {
    "date": "2026-10-21",
    "title": "commit to documented steps instead of handing off to 'confirm' when the knowledge alrea…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "commit to documented steps instead of handing off to 'confirm' when the knowledge already has them; vision answer may live on a different screen than the screenshot"
    ]
  },
  {
    "date": "2026-10-21",
    "title": "send screenshot bytes inline (base64) for vision instead of a relative URL the model AP…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "send screenshot bytes inline (base64) for vision instead of a relative URL the model API can't fetch"
    ]
  },
  {
    "date": "2026-10-20",
    "title": "Jesse reads screenshots/PDFs (vision) as context for a grounded answer instead of handi…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse reads screenshots/PDFs (vision) as context for a grounded answer instead of handing off, behind FEATURE_AI_RESPONDER_VISION"
    ]
  },
  {
    "date": "2026-10-20",
    "title": "raise per-chat message cap 12->40 and stop budget escalations from resume-looping (Jess…",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "raise per-chat message cap 12->40 and stop budget escalations from resume-looping (Jesse was handing off mid-flow on long helpful chats)"
    ]
  },
  {
    "date": "2026-10-20",
    "title": "Jesse learns from resolved human chats — anonymised lesson store + live retrieval into …",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Jesse learns from resolved human chats — anonymised lesson store + live retrieval into answers, behind FEATURE_AI_RESPONDER_LEARN"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "slim jesse-brain to glossary + rules (drop redundant docs/process); add product-options…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "slim jesse-brain to glossary + rules (drop redundant docs/process); add product-options → Bundle options term mapping"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "translate the user's wording to real WeQuote terms via the glossary and merge into the …",
    "tags": [
      "AI"
    ],
    "bullets": [
      "translate the user's wording to real WeQuote terms via the glossary and merge into the answer-doc search (fixes 'product options' finding Bundle options docs)"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "Jesse answers from the copilot (wequote-docs) corpus, logic + glossary from jesse-brain…",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Jesse answers from the copilot (wequote-docs) corpus, logic + glossary from jesse-brain; two-pass glossary translation; carry clarify/retrieval fixes"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "break clarify loop + fix retrieval on complex questions (distil long messages to keywor…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "break clarify loop + fix retrieval on complex questions (distil long messages to keywords, wider context, inventory synonyms); recognise known features"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "break the clarify loop — commit after one question, recognise known features instead of…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "break the clarify loop — commit after one question, recognise known features instead of re-asking (glossary only for unfamiliar terms)"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "Meeting mirror: ignoreCursors backfill mode — re-lists the full window regardless of up…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Meeting mirror: ignoreCursors backfill mode — re-lists the full window regardless of updated-time cursors so rule changes can reach old events (Digital Garage miss)."
    ]
  },
  {
    "date": "2026-10-19",
    "title": "own 'are you an AI', context-stitch short replies, hold human-requested handoffs, close…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "own 'are you an AI', context-stitch short replies, hold human-requested handoffs, close on wind-down; glossary entry for changing a project's customer"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "jesse-brain corpus on its own skill slot; Jesse reads rules from SKILL.md; re-pilot to …",
    "tags": [
      "AI"
    ],
    "bullets": [
      "jesse-brain corpus on its own skill slot; Jesse reads rules from SKILL.md; re-pilot to np@ only"
    ]
  },
  {
    "date": "2026-10-19",
    "title": "jesse-brain corpus on its own skill slot; Jesse reads rules from SKILL.md; re-pilot to …",
    "tags": [
      "AI"
    ],
    "bullets": [
      "jesse-brain corpus on its own skill slot; Jesse reads rules from SKILL.md; re-pilot to np@ only"
    ]
  },
  {
    "date": "2026-10-16",
    "title": "Meeting mirror: every meeting with a lead bridges into its UNFINISHED onboarding's Sess…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Meeting mirror: every meeting with a lead bridges into its UNFINISHED onboarding's Sessions (title rule kept for finished ones)."
    ]
  },
  {
    "date": "2026-10-16",
    "title": "Contracts Part C: WeQuote Terms of Service v2.1 (Oct 2026) — page HTML + PDF blocks reg…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contracts Part C: WeQuote Terms of Service v2.1 (Oct 2026) — page HTML + PDF blocks regenerated from Lee's source; applies to all unsigned contracts immediately."
    ]
  },
  {
    "date": "2026-10-15",
    "title": "Contract lead picker: opt-in includeSuppliers filter so £0-MRR suppliers (Dubai Audio) …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contract lead picker: opt-in includeSuppliers filter so £0-MRR suppliers (Dubai Audio) are linkable; the supplier rule stays in force everywhere else."
    ]
  },
  {
    "date": "2026-10-15",
    "title": "Contract lead picker: include soft-archived leads (ARCHIVED tag) and show each lead's s…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contract lead picker: include soft-archived leads (ARCHIVED tag) and show each lead's stage — every lead linkable across all stages; contract flow never touches stage."
    ]
  },
  {
    "date": "2026-10-15",
    "title": "typing-aware message batching — hold Jesse while the visitor is still typing (no more s…",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "typing-aware message batching — hold Jesse while the visitor is still typing (no more split replies)"
    ]
  },
  {
    "date": "2026-10-15",
    "title": "Onboarding feed: first auto-pull 2 min after startup (no more full-cadence blind window…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding feed: first auto-pull 2 min after startup (no more full-cadence blind window / 'feed never synced' after restarts)."
    ]
  },
  {
    "date": "2026-10-15",
    "title": "Onboarding feed hardening: auto-pull defaults ON (30 min), heartbeat audit row per pull…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding feed hardening: auto-pull defaults ON (30 min), heartbeat audit row per pull, 15-min staleness watchdog with critical bell alert, feed-freshness chip on the board header."
    ]
  },
  {
    "date": "2026-10-15",
    "title": "Jesse phase 2 — debounce visitor messages so chunked texting is answered as one thought",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Jesse phase 2 — debounce visitor messages so chunked texting is answered as one thought"
    ]
  },
  {
    "date": "2026-10-15",
    "title": "Jesse phase 1 — more grounding + strict 'only say what the knowledge backs up' (anti-ha…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse phase 1 — more grounding + strict 'only say what the knowledge backs up' (anti-hallucination)"
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Emails tab: Gmail-style threading — one expandable card per thread, every message shown…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Emails tab: Gmail-style threading — one expandable card per thread, every message shown in full with avatar/sender/clean body, thread-level pagination."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Sidebar: icons for Task Dashboard (clipboard-check), Call Queue (phone), Metrics Glossa…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Sidebar: icons for Task Dashboard (clipboard-check), Call Queue (phone), Metrics Glossary (open book) — no more empty circles."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Onboardings cards: visual hierarchy pass — headline company name, two-volume chips (ale…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings cards: visual hierarchy pass — headline company name, two-volume chips (alerts loud, facts quiet), borderless divided mini-cells, promoted MRR, ghost archive."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Contracts: schedule start = go-live date (migration 137) — staff-set in the Studio at a…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contracts: schedule start = go-live date (migration 137) — staff-set in the Studio at any status, countersign date as fallback; Monitoring payments/renewals run from it."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Monitoring: Upcoming Renewals window 90→60 days (contracts + WeQuote-managed subs).",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Monitoring: Upcoming Renewals window 90→60 days (contracts + WeQuote-managed subs)."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Contract Manager: cards clamp to their columns on all three tabs (min-w-0 shrink + name…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract Manager: cards clamp to their columns on all three tabs (min-w-0 shrink + name truncation)."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Contract Manager plan split: Enterprise = our contracts, Lite/Pro/Premium = WeQuote-man…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract Manager plan split: Enterprise = our contracts, Lite/Pro/Premium = WeQuote-managed read-only mirrors (migration 136); Old T&Cs rolling monthly with plan-chooser convert; New T&Cs merges mirrors + contracts with Upgrade-to-Enterprise; Monitoring includes WeQuote-managed subs."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Sales Board: remove the Qualified column — qualification no longer affects this board (…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sales Board: remove the Qualified column — qualification no longer affects this board (demo bookings still pull into Demos Booked)."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Contract Manager: three views (Monitoring primary, Old T&Cs burn-down, New T&Cs with pe…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contract Manager: three views (Monitoring primary, Old T&Cs burn-down, New T&Cs with per-company history); many contracts per lead with renewals; legacy book; derived payment schedule with manual paid/failed marks (migration 135)."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Onboardings: Archived column (archive/unarchive from cards, migration 134, sweep+push e…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Onboardings: Archived column (archive/unarchive from cards, migration 134, sweep+push exempt); surface real server error on failed card moves."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Onboardings cards: compact row drops duplicate Plan/Stage cells (focal panel keeps them…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings cards: compact row drops duplicate Plan/Stage cells (focal panel keeps them); focal panel slimmed to one line per cell in all modes."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Onboardings board: compact cards keep ALL information — stacked blocks become one slim …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: compact cards keep ALL information — stacked blocks become one slim six-cell row (plan/stage/meetings/email/go-live/owner), stage strip stays; nothing hidden on collapse."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Clock wall: collapsible to a slim one-line bar (inline times + active filter kept, clic…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Clock wall: collapsible to a slim one-line bar (inline times + active filter kept, click to expand); open by default, state persisted across reloads."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Onboardings board: collapsible columns (strip keeps count + drop target, state persiste…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: collapsible columns (strip keeps count + drop target, state persisted) — remaining columns widen and cards render compact (header/pills/focal panel only) so more fit on screen."
    ]
  },
  {
    "date": "2026-10-14",
    "title": "Onboardings: last-email/last-meeting batch rewritten as group-wise max (indexed GROUP B…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: last-email/last-meeting batch rewritten as group-wise max (indexed GROUP BY + exact-row fetch) — the old global sort over leads×12 rows pegged MySQL after the live sync tripled the board."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Contract page: SOW/Terms collapsibles strip the document's own part header by tag (clas…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Contract page: SOW/Terms collapsibles strip the document's own part header by tag (class-string hunt missed 'part-body terms' and rendered a duplicate PART C header inside the fold)."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Contracts: Included lines show no money anywhere — quantity + 'Included' only (page, PD…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contracts: Included lines show no money anywhere — quantity + 'Included' only (page, PDF, Studio preview, summary rows); they are simply part of the plan's price."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Contracts: SOW on/off per contract (page+PDF, send gate adjusts); 'Included in price' p…",
    "tags": [
      "Mobile"
    ],
    "bullets": [
      "Contracts: SOW on/off per contract (page+PDF, send gate adjusts); 'Included in price' per line (Snagg/modules/integrations — qty shown, £0, totals unaffected); locked frequency shows a single column on page+PDF; emojis stripped from pages/emails/banners; mobile layout for the public agreement page."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "selectable/copyable chat messages + visible selection highlight (::selection var was un…",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "selectable/copyable chat messages + visible selection highlight (::selection var was undefined)"
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Onboardings: Gold quotes always use a REQUIRED custom Stripe payment link — link input …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: Gold quotes always use a REQUIRED custom Stripe payment link — link input on the Assign Gold card + 'New Gold quote' plan-bar modal (new price + fresh link; payment back to pending, customer banner updates)."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Jesse voice + retention rules — resolve first, ask what a human request is about, no AI…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse voice + retention rules — resolve first, ask what a human request is about, no AI-sounding syntax"
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Contract PDF: measured signature boxes (no clipped Recorded/commencement note), WinAnsi…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract PDF: measured signature boxes (no clipped Recorded/commencement note), WinAnsi-safe glyphs for discounts/selected marker, header repeated on split tables, bullets measured before drawing."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Onboardings board: Not Started shows only ONBOARDING REQUIRED flags + plan-assigned rec…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: Not Started shows only ONBOARDING REQUIRED flags + plan-assigned records — stray staging-era auto-ticks no longer surface the old live book (the 156 bug)."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Onboardings: went-paid sweep keys on WeQuote's own activated_at from the org feed (stag…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: went-paid sweep keys on WeQuote's own activated_at from the org feed (staging_meta) — deals.activated_at reflected our sync date and flagged half the book; paid status + 60-day window, no stamp = no flag."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Onboardings board: test/staging/dummy-named orgs filtered out at the API regardless of …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: test/staging/dummy-named orgs filtered out at the API regardless of plan/progress (OB_BOARD_NAME_WHITELIST for unlucky real names, default scenex; OB_HIDE_TEST=0 escape hatch; imports never hidden)."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Onboardings board: every column sorted by last held meeting (own sessions first, lead C…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: every column sorted by last held meeting (own sessions first, lead CRM meeting fallback, never-met last); Not Started keeps ONBOARDING REQUIRED pinned on top."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Onboardings: valuecase-import column pins never auto-clear (Graduated=Complete, rest=In…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: valuecase-import column pins never auto-clear (Graduated=Complete, rest=In Progress — import status is the truth for the historic book; new WeTask onboardings keep task-driven completion); went-paid sweep skips test/staging-named accounts."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Meeting mirror: Claude auto-completes outstanding '(From calls)' customer asks when fre…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Meeting mirror: Claude auto-completes outstanding '(From calls)' customer asks when fresh Gemini notes clearly show them provided/completed (conservative, audited)."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Onboardings: OB_EMAILS_PAUSED=1 kill-switch silences all onboarding emails (team batche…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: OB_EMAILS_PAUSED=1 kill-switch silences all onboarding emails (team batches, uploads, plan-required, customer plan/payment/meeting) while the cutover backfill settles; bell alerts unaffected."
    ]
  },
  {
    "date": "2026-10-13",
    "title": "Customer onboarding page: emojis removed from the payment banners (assigned / outstandi…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Customer onboarding page: emojis removed from the payment banners (assigned / outstanding / failed / processing)."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings cutover rules: went-paid sweep honours the import sentinel + a 60-day go-li…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Onboardings cutover rules: went-paid sweep honours the import sentinel + a 60-day go-live window; Not Started curated to flagged/touched records; WeQuote iframe push gated to imported + recent-paid + engaged companies only."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings: went-paid sweep skips requested_at-stamped onboardings — the Valuecase imp…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: went-paid sweep skips requested_at-stamped onboardings — the Valuecase import's sentinel keeps the historic live book out of ONBOARDING REQUIRED at cutover."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Valuecase cutover prep: wq_valuecase_import holding table (migration 133) — staged meet…",
    "tags": [
      "Mobile"
    ],
    "bullets": [
      "Valuecase cutover prep: wq_valuecase_import holding table (migration 133) — staged meeting history + plans + customer health for the 50 exported companies."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Meeting mirror: time-bounded event listing + full pagination (old 500 cap silently drop…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Meeting mirror: time-bounded event listing + full pagination (old 500 cap silently dropped events and advanced the cursor past them); truncation holds the cursor; sweep reports bridged count."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Meeting matcher: every deal behind every contact row sharing an attendee email is a can…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Meeting matcher: every deal behind every contact row sharing an attendee email is a candidate (org users = contacts, so any user of an org matches its lead); company-name-in-domain rung; mirror every 5 min; org-users sync default 20 min."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Meeting matcher: expose all candidate leads (dealCandidates); onboarding bridge attache…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Meeting matcher: expose all candidate leads (dealCandidates); onboarding bridge attaches to the first candidate WITH an onboarding; betterDeal finally ranks expired trials below active deals."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings: single Sessions timeline (Bookings tab merged in — summary/blockers/next-a…",
    "tags": [
      "CRM",
      "Support",
      "AI"
    ],
    "bullets": [
      "Onboardings: single Sessions timeline (Bookings tab merged in — summary/blockers/next-action/covered/reschedule per session; book buttons on the timeline); per-session Gemini tasks/notes/transcript + pending-tasks side panel; bridge filtered to onboarding/training meetings; extracted tasks tagged with their session (src)."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings: Sessions timeline tab (oldest→latest, latest open; per-session tasks/notes…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Onboardings: Sessions timeline tab (oldest→latest, latest open; per-session tasks/notes/transcript + pending-tasks side panel); bridge filtered to onboarding/training meetings; extracted tasks tagged with their session (src)."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Meeting mirror: bridge matched calendar meetings into wq_onboarding_meetings (upcoming+…",
    "tags": [
      "CRM",
      "Support",
      "AI"
    ],
    "bullets": [
      "Meeting mirror: bridge matched calendar meetings into wq_onboarding_meetings (upcoming+held, hours tracked, slot-adoption dedupe, transcript ref); Gemini 'Suggested next steps' → tickable onboarding custom tasks; email-sync matching rung for free-mail attendees; 15-min cadence, cap 80."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings: email info@/nl@/am@ (OB_PLAN_REQUIRED_EMAILS) when a company goes paid and…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: email info@/nl@/am@ (OB_PLAN_REQUIRED_EMAILS) when a company goes paid and is flagged ONBOARDING REQUIRED — branded template from wequote@, lead link to assign the plan."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings cards: contrast pass — contact-pulse values 11px dark, darker icons/labels/…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings cards: contrast pass — contact-pulse values 11px dark, darker icons/labels/footer, readable empty states (first cut was too greyed-out)."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings board: card redesigned with visual hierarchy — plan+stage focal panel, 3-up…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: card redesigned with visual hierarchy — plan+stage focal panel, 3-up contact pulse grid (next meeting / last email / last meeting) with icons, quiet go-live+owner footer; flat row list removed."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings board: country flag on company name + Last email (us→them/them→us, from→to …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: country flag on company name + Last email (us→them/them→us, from→to on hover) and Last meeting (date + who) rows from the lead's email sync and bookings."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Sidebar: CRM nav reordered (Sales Board / Qualification Board / Contract Manager / Onbo…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sidebar: CRM nav reordered (Sales Board / Qualification Board / Contract Manager / Onboardings / Customer Success / Shows-Events / Event Planner / Leads first); Event Planner map icon; Import arrow-down-tray icon (key fixed to the real route)."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Sidebar: rocket-launch icon for Onboardings (was the generic dot fallback).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sidebar: rocket-launch icon for Onboardings (was the generic dot fallback)."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings: ONBOARDING REQUIRED — customer page shows assign-message only (request but…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: ONBOARDING REQUIRED — customer page shows assign-message only (request button removed); went-paid sweep flags awaiting onboardings (top of Not Started, blue pill, alert); board cards show employees from qualification company size."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Onboardings: Request-an-Onboarding flow — customer plan cards replaced by one request b…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: Request-an-Onboarding flow — customer plan cards replaced by one request button (plan_state 'requested', migration 132); admin assigns the plan (Assign buttons + blue requested banner + board pill + alert); customer gets the 'You have been assigned a <plan> Onboarding Plan' banner with terms, amount due and Pay now link."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Sales Board: /crm/sales-board duplicate of the kanban board with the pre-remodel legacy…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sales Board: /crm/sales-board duplicate of the kanban board with the pre-remodel legacy columns (Qualified / Free Trial Sign Up / Demos Booked etc); main board renamed Qualification Board (keeps the new Qualifying/Qualified layout); same component via a legacy prop."
    ]
  },
  {
    "date": "2026-10-12",
    "title": "Sales Board: /crm/sales-board duplicate of the kanban board with the pre-remodel legacy…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sales Board: /crm/sales-board duplicate of the kanban board with the pre-remodel legacy columns (Qualified / Free Trial Sign Up / Demos Booked etc); main Board keeps the new Qualifying/Qualified layout; same component via a legacy prop."
    ]
  },
  {
    "date": "2026-10-09",
    "title": "Board remodel: Demos/Trials split into Qualifying/Qualified columns; Qualify button + q…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Board remodel: Demos/Trials split into Qualifying/Qualified columns; Qualify button + questions popup (manual sticky qualification, migration 131); held-demo auto-qualify sweep; trial+held-demo backfill; legacy segment aliases."
    ]
  },
  {
    "date": "2026-10-09",
    "title": "Meeting Gemini notes visible to everyone; multi-recorder support (wq_crm_booking_notes,…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Meeting Gemini notes visible to everyone; multi-recorder support (wq_crm_booking_notes, migration 130) with per-recorder accordions on the Meetings tab."
    ]
  },
  {
    "date": "2026-10-09",
    "title": "Meeting mirror: mirrored calendar meetings become real wq_crm_bookings rows (done/past)…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Meeting mirror: mirrored calendar meetings become real wq_crm_bookings rows (done/past) so they show on the lead's Meetings tab; demo + existing-booking dupe guards."
    ]
  },
  {
    "date": "2026-10-09",
    "title": "Meeting mirror: hourly sweep of six team calendars — meeting-held activities on matched…",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Meeting mirror: hourly sweep of six team calendars — meeting-held activities on matched leads + Gemini notes/transcripts exported as-host into each company's Drive Transcripts folder; recordings linked; wq_drive_docs dedupe."
    ]
  },
  {
    "date": "2026-10-09",
    "title": "Onboarding embed: AUTO-CHECK pill gets an instant styled tooltip (native title bubble w…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Onboarding embed: AUTO-CHECK pill gets an instant styled tooltip (native title bubble was slow/easy to miss)."
    ]
  },
  {
    "date": "2026-10-09",
    "title": "Onboarding embed: blue AUTO-CHECK pill on AUTO steps with hover explanation (auto-compl…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Onboarding embed: blue AUTO-CHECK pill on AUTO steps with hover explanation (auto-completes from WeQuote, up to ~5 min) — greyed boxes alone read as broken."
    ]
  },
  {
    "date": "2026-10-08",
    "title": "Onboarding email notifications from wequote@: batched team emails for completed steps (…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding email notifications from wequote@: batched team emails for completed steps (10-min batch, 45-min floor, customer+auto ticks), immediate team email on customer uploads, immediate customer email on staff uploads (migration 129 notify_state)."
    ]
  },
  {
    "date": "2026-10-08",
    "title": "Onboarding watch lists: add quoting_setup module (Robert's v2 reply) — changed lists ma…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding watch lists: add quoting_setup module (Robert's v2 reply) — changed lists make the sweep re-send every paid account's config; adds the ack doc for Robert."
    ]
  },
  {
    "date": "2026-10-08",
    "title": "Build fix: gmailAttachments return type includes 'from'; Onboarding.paymentStatus type …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Build fix: gmailAttachments return type includes 'from'; Onboarding.paymentStatus type widened to processing/failed."
    ]
  },
  {
    "date": "2026-10-08",
    "title": "Onboarding: permanent SALES/TECHNICIANS captions under the Team size inputs (both sides…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding: permanent SALES/TECHNICIANS captions under the Team size inputs (both sides) — placeholders vanished once a number was entered."
    ]
  },
  {
    "date": "2026-10-08",
    "title": "Onboarding payments: handle the three Stripe checkout events (completed / async_payment…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding payments: handle the three Stripe checkout events (completed / async_payment_succeeded / async_payment_failed) — paid clears banner, delayed methods show amber processing, failures keep the plan active with a blaring try-again banner; customer emails + admin alerts per state; raw-body signature verification."
    ]
  },
  {
    "date": "2026-10-08",
    "title": "Onboarding: real Stripe Payment Links for Bronze/Silver (new-tab, optimistic activation…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding: real Stripe Payment Links for Bronze/Silver (new-tab, optimistic activation, blaring PAYMENT OUTSTANDING banner until webhook/staff confirm); all booking buttons -> calendly.com/wequote/onboarding-training-call."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Drive docs mirror: inbound-only — mirror only attachments the lead sent us (from:<lead>…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Drive docs mirror: inbound-only — mirror only attachments the lead sent us (from:<lead>), skip wetech/wetask senders; cleanup pass trashes previously mirrored outbound files."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Drive docs mirror: sweep all six team mailboxes (info/wequote/am/nl/lr/jc @wetech.cloud…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Drive docs mirror: sweep all six team mailboxes (info/wequote/am/nl/lr/jc @wetech.cloud, DRIVE_DOCS_MAILBOXES override) with RFC-822 Message-ID cross-mailbox dedupe."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Drive docs mirror: own Gmail client impersonating the lead mailbox (DRIVE_DOCS_GMAIL_SU…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Drive docs mirror: own Gmail client impersonating the lead mailbox (DRIVE_DOCS_GMAIL_SUBJECT, default info@wetech.cloud) instead of the support@ ticket mailbox — the backfill now actually sees lead email."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "CRM: drive_folder_url on every lead (migration 127) — Drive chip on lead hero/modal + a…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "CRM: drive_folder_url on every lead (migration 127) — Drive chip on lead hero/modal + all board cards; HAL sync feed returns it and new hal_set_drive_folder writes it (daily Drive sync)."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Drive mirror: hourly 'Documents Received' sweep — email attachments (Gmail API) + onboa…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Drive mirror: hourly 'Documents Received' sweep — email attachments (Gmail API) + onboarding task uploads copied into each lead's shared-drive folder; wq_drive_docs dedupe ledger (migration 128)."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Onboarding: audit+log every incoming onboarding_step event (matched or not); quote coun…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding: audit+log every incoming onboarding_step event (matched or not); quote counter accepts count-less events as +1 increments. Adds the v2 trigger spec for Robert."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "HAL: add hal_drive_sync_leads — read-only feed (company, wequote_account_id, country, s…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "HAL: add hal_drive_sync_leads — read-only feed (company, wequote_account_id, country, stage, contact) for the scheduled Google Drive company-folder sync."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Contracts: branded pdfkit PDF (signature placed in Acceptance, full SOW+ToS, footer ban…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contracts: branded pdfkit PDF (signature placed in Acceptance, full SOW+ToS, footer band); on sign, PDF-attached emails to the lead's main email + assignee; PDF preview (Studio) and Download PDF (customer) buttons; email service gains attachments."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Contracts Part B: number fields drop the example-value placeholders — blank until the u…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contracts Part B: number fields drop the example-value placeholders — blank until the user types, so unfilled is unambiguous."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Contracts Part B: Yes/No dropdowns + date pickers + number inputs; stale-state fix so t…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contracts Part B: Yes/No dropdowns + date pickers + number inputs; stale-state fix so the send gate unlocks at 21/21; exact 'Please complete Section B' message on the greyed button."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Contracts: Part-B SOW fill-ins (21 labelled slots, migration 126) rendered bold on the …",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contracts: Part-B SOW fill-ins (21 labelled slots, migration 126) rendered bold on the customer page; sending gated — Mark-as-sent refused server-side and link copy hidden until all filled; Customer view stays open for preview."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Sidebar: document icon for Contract Manager.",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Sidebar: document icon for Contract Manager."
    ]
  },
  {
    "date": "2026-10-07",
    "title": "Onboarding: Add-file/link on upload steps (customer + staff, links allowed staff-side);…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding: Add-file/link on upload steps (customer + staff, links allowed staff-side); per-customer step tutorials (migration 125) with See-tutorial button on the customer page."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contract page: summary before Acceptance, section 6 fold (fixed the lost-under-5), SOW/…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract page: summary before Acceptance, section 6 fold (fixed the lost-under-5), SOW/ToS/key-terms all collapsible w/o heading repeats, journey+SOW fills from contract, sticky pill nav."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contracts: customer page rebuilt on the agreement HTML (verbatim CSS/journey/SOW/collap…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contracts: customer page rebuilt on the agreement HTML (verbatim CSS/journey/SOW/collapsible ToS/footer, parties fills injected); per-section FIXED-BY-US/THEY-CHOOSE (default fixed, shownPackages subset, training always ours)."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contract summary: annual-first headline total when paying annually (monthly small below…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract summary: annual-first headline total when paying annually (monthly small below) + full-width green savings banner; Studio preview mirrors."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contract discount matrix: annual cells lead with the yearly figure (monthly equivalent …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contract discount matrix: annual cells lead with the yearly figure (monthly equivalent small); every term×payment cell shows the saving vs standard over that term."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contract Manager P2+P3: public customer agreement page at /contract/:slug — plan/add-on…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract Manager P2+P3: public customer agreement page at /contract/:slug — plan/add-ons/training pickers, live discount matrix, committed-subscription summary, draw/type digital signing with lock."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contract Studio: staff set only currency + prices; plan/add-ons/Snagg/integrations/trai…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Contract Studio: staff set only currency + prices; plan/add-ons/Snagg/integrations/training/term/frequency are customer selections (training joins selections, currency-aware money everywhere)."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contract Manager: page deals in 1000s (endpoint caps limit) + includeTerminal so cancel…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contract Manager: page deals in 1000s (endpoint caps limit) + includeTerminal so cancelled/closed-lost/archived filters populate."
    ]
  },
  {
    "date": "2026-10-06",
    "title": "Contract Manager P1: leads list w/ stage filters + contract states; Contract Studio (pa…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Contract Manager P1: leads list w/ stage filters + contract states; Contract Studio (parties, plan/pricing overrides, customer-choice options, proserv, live preview w/ discount matrix, link popup); price book in DB; migration 124; public contract API ready for P2."
    ]
  },
  {
    "date": "2026-10-05",
    "title": "Support/Dev mode is per-tab (sessionStorage) so tabs don't bleed on refresh",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Support/Dev mode is per-tab (sessionStorage) so tabs don't bleed on refresh"
    ]
  },
  {
    "date": "2026-10-05",
    "title": "nginx conf: Cache-Control no-cache on the SPA document (stale cached index.html pointed…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "nginx conf: Cache-Control no-cache on the SPA document (stale cached index.html pointed at deleted hashed bundles → blank page); hashed assets stay immutable-cached."
    ]
  },
  {
    "date": "2026-10-05",
    "title": "Onboarding hours: add-hours buttons removed; '4/4 complete + X over' on both sides; act…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Onboarding hours: add-hours buttons removed; '4/4 complete + X over' on both sides; actionable over-hours notice (page banner + kanban strip) that raises the chargeable banner on the customer page; migration 123 over_notice."
    ]
  },
  {
    "date": "2026-10-05",
    "title": "Onboarding non-linear: all stages open from day one except wh/pr/bp module stages — sta…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding non-linear: all stages open from day one except wh/pr/bp module stages — staff-only confirmed toggles (customers read-only, server-refused); bespoke switch-driven; Top-up hours button."
    ]
  },
  {
    "date": "2026-10-02",
    "title": "Onboarding attachments: customer add-file/add-link on custom tasks, attachment pills (t…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding attachments: customer add-file/add-link on custom tasks, attachment pills (title·type·size, new tab) under steps+tasks both sides, Page/Tutorial kind select on Add task."
    ]
  },
  {
    "date": "2026-10-02",
    "title": "Onboarding checkpoints: the ↗ step/custom-task link is labelled 'Go to page ↗' on staff…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding checkpoints: the ↗ step/custom-task link is labelled 'Go to page ↗' on staff + customer sides."
    ]
  },
  {
    "date": "2026-10-02",
    "title": "Onboarding plans: upward-only upgrades (customer modal + staff popup, Gold with custom …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding plans: upward-only upgrades (customer modal + staff popup, Gold with custom hours), staff hours top-ups that survive upgrades, over-hours red bar with add-the-extra-hours prompt, Gold customers request more hours."
    ]
  },
  {
    "date": "2026-10-02",
    "title": "CRM clock wall: labels show tz abbreviations (GMT/EST/BST, DST-aware via Intl) with fla…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "CRM clock wall: labels show tz abbreviations (GMT/EST/BST, DST-aware via Intl) with flags kept; cities move to the tooltip; filter chip uses the abbreviation."
    ]
  },
  {
    "date": "2026-10-02",
    "title": "CORS: /api/public/onboarding/* accepts any origin without credentials (WeQuote's sandbo…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "CORS: /api/public/onboarding/* accepts any origin without credentials (WeQuote's sandboxed iframe sends Origin null, which blanked the embed); all other routes keep the strict allowlist."
    ]
  },
  {
    "date": "2026-10-02",
    "title": "Onboarding staff tab: all Book buttons open Calendly in a new tab; internal meeting for…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding staff tab: all Book buttons open Calendly in a new tab; internal meeting form demoted to a 'log manually' link (still drives cards + hours)."
    ]
  },
  {
    "date": "2026-10-02",
    "title": "Onboarding bookings: customer buttons → Calendly (calendly.com/wequote/demo), slot pick…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Onboarding bookings: customer buttons → Calendly (calendly.com/wequote/demo), slot picker + Google Calendar push removed; staff cards get full status pills (CANCELLED/NO SHOW); stageIndex 4→8; mock /pay page fetch-based."
    ]
  },
  {
    "date": "2026-10-01",
    "title": "Onboarding embed: TEST-MODE payment as in-page modal (fetch confirm, no navigation) — i…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Onboarding embed: TEST-MODE payment as in-page modal (fetch confirm, no navigation) — iframe page changes were refused; real Stripe links unaffected."
    ]
  },
  {
    "date": "2026-10-01",
    "title": "Onboarding mock pay pages: allow framing from WeQuote (CSP frame-ancestors on the three…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding mock pay pages: allow framing from WeQuote (CSP frame-ancestors on the three /pay HTML routes only) — the iframe showed Chrome's crashed page on Pay."
    ]
  },
  {
    "date": "2026-10-01",
    "title": "Onboardings board: columns gated by plan selection — no plan = Not Started regardless o…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: columns gated by plan selection — no plan = Not Started regardless of ticks; plan active = In Progress until all counted stages complete."
    ]
  },
  {
    "date": "2026-10-01",
    "title": "Onboardings board: select step_index/n/subs in the bulk steps query — rules engine matc…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: select step_index/n/subs in the bulk steps query — rules engine matched on stage+step index, so the board computed every card as Not Started (Test Boca Tech bug)."
    ]
  },
  {
    "date": "2026-10-01",
    "title": "Onboarding: per-step Go-to-page/Watch-tutorial/Book actions (alias-resolved, env-based …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding: per-step Go-to-page/Watch-tutorial/Book actions (alias-resolved, env-based host for the cutover); custom tasks take an optional URL; customer page shows staff-added tasks."
    ]
  },
  {
    "date": "2026-10-01",
    "title": "Onboarding Checkpoints: + Add task per stage (custom tasks with requires-upload toggle)…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding Checkpoints: + Add task per stage (custom tasks with requires-upload toggle), tick/remove with server-enforced upload gate surfaced."
    ]
  },
  {
    "date": "2026-10-01",
    "title": "Onboarding About card: Team size sub-labels become input placeholders so all three colu…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Onboarding About card: Team size sub-labels become input placeholders so all three columns top-align (staff + customer embed)."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Onboardings: push paid companies' unique URLs to WeQuote (section-3 POST) — instant on …",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Onboardings: push paid companies' unique URLs to WeQuote (section-3 POST) — instant on paid webhook + sweep after pulls; migration 121 push-state; nginx frame-ancestors for /crm/onboarding/ only."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Onboardings: standalone /crm/onboardings/:id page for lead-less records; board/risk row…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: standalone /crm/onboardings/:id page for lead-less records; board/risk rows route there; DealOnboarding loads by dealId or onboardingId."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "staging pull creates standalone onboardings only — never links to live CRM leads",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "staging pull creates standalone onboardings only — never links to live CRM leads"
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Onboarding tab: plan bar hoisted to the top with Customer link (popup: link+embed+rotat…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Onboarding tab: plan bar hoisted to the top with Customer link (popup: link+embed+rotate) and Customer view buttons; old link row removed; awaiting banner gets the same buttons."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Staff Bookings v2: collapsible meeting cards — What's been done + View transcript, Bloc…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Staff Bookings v2: collapsible meeting cards — What's been done + View transcript, Blockers, Next action (owner+due), Covered-on-the-call checklist; upcoming = Reschedule/Cancel only."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Onboarding staff tab: About-the-business card (modules lock/unlock stages live, account…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboarding staff tab: About-the-business card (modules lock/unlock stages live, accounting dropdown, team-size inputs, to-confirm pill) — same store as the customer card."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Onboardings board: fluid full-width columns; stage strip uses spec-filtered segments (s…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings board: fluid full-width columns; stage strip uses spec-filtered segments (skips hidden/add-on/Grow), overflow-guarded labels, dimmed locked segments."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "assets: new Jesse avatar (jesse-avatar.jpg) + repoint persona default",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "assets: new Jesse avatar (jesse-avatar.jpg) + repoint persona default"
    ]
  },
  {
    "date": "2026-09-30",
    "title": "assets: add Andy Musgrave agent avatar (served at /api/widget/andy-musgrave.jpg)",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "assets: add Andy Musgrave agent avatar (served at /api/widget/andy-musgrave.jpg)"
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Bookings (staff + customer embed): stage icon badges matching Checkpoints, carded stage…",
    "tags": [
      "Widget"
    ],
    "bullets": [
      "Bookings (staff + customer embed): stage icon badges matching Checkpoints, carded stage sections with steps/hours chips, General card for stage-less calls, grouped customer meeting list."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Lead page: darker canvas + carded content on every tab and the details rail; distinct v…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Lead page: darker canvas + carded content on every tab and the details rail; distinct vector icons for all nine onboarding stages (staff + customer embed)."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Onboarding: meetings expose transcriptRef + structured notes to staff; transcript side-…",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Onboarding: meetings expose transcriptRef + structured notes to staff; transcript side-sheet renders the real text (link/empty fallbacks)."
    ]
  },
  {
    "date": "2026-09-30",
    "title": "Onboarding v2 core: 9-stage verbatim config, rules engine (facts/locks/column/notices),…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Onboarding v2 core: 9-stage verbatim config, rules engine (facts/locks/column/notices), server-enforced tick matrix with LIVE customer ticking, migration 120 (5→9 remap, mods/biz/custom, files, resources, meeting notes), new staff+public endpoints, 26 tests."
    ]
  },
  {
    "date": "2026-09-29",
    "title": "Attention widget: ticked alerts no longer resurrect on cache rebuild (read flag name mi…",
    "tags": [
      "Widget"
    ],
    "bullets": [
      "Attention widget: ticked alerts no longer resurrect on cache rebuild (read flag name mismatch); all ticks belt-and-braces persisted in attention_done."
    ]
  },
  {
    "date": "2026-09-29",
    "title": "Attention widget: Completed read-only + excluded from waiting count; Calls only card_re…",
    "tags": [
      "Widget"
    ],
    "bullets": [
      "Attention widget: Completed read-only + excluded from waiting count; Calls only card_removed/trial_expired; Trials ≤3 days; qualification alerts filtered."
    ]
  },
  {
    "date": "2026-09-29",
    "title": "Attention widget: CS dismiss/resolve marks the risk item done + invalidates the item ca…",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Attention widget: CS dismiss/resolve marks the risk item done + invalidates the item cache instantly; restore un-dones and rebuilds; dismissed gets its own team-notice wording."
    ]
  },
  {
    "date": "2026-09-29",
    "title": "Attention dock: auto-open only on the first CRM load of each calendar day (localStorage…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Attention dock: auto-open only on the first CRM load of each calendar day (localStorage-tracked); minimised on every later reload."
    ]
  },
  {
    "date": "2026-09-29",
    "title": "Customer Success: Dismiss (required note, Dismissed tab, Restore) + Resolve (required n…",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Customer Success: Dismiss (required note, Dismissed tab, Restore) + Resolve (required note, 30-day suppression with auto-expiry back to At Risk) — overlay inside getQuoteRisk so the widget agrees."
    ]
  },
  {
    "date": "2026-09-29",
    "title": "contextual clarify from chat history instead of a canned 'what would you like help with…",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "contextual clarify from chat history instead of a canned 'what would you like help with' reset"
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings: test-only restart (server-guarded on staging_meta.test) with TEST banner/c…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings: test-only restart (server-guarded on staging_meta.test) with TEST banner/chip; obReset endpoint + UI."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 8: 18 unit tests (token crypto, column rules, hours maths, risk trigg…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings Phase 8: 18 unit tests (token crypto, column rules, hours maths, risk triggers, payments, step map) + QA report against the acceptance list."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 7: Google Calendar sync for onboarding meetings (Meet links, invites,…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Onboardings Phase 7: Google Calendar sync for onboarding meetings (Meet links, invites, reschedule/cancel), owner-busy availability, held sweep + transcript pick-up, internal alerts + customer emails, staging webhook routing with auto-step ticking."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 6: public customer embed page (WeQuote-styled, view-only, plan picker…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Onboardings Phase 6: public customer embed page (WeQuote-styled, view-only, plan picker, slot-picker booking, iframe auto-resize) + availability/meetings public endpoints + staff Embed modal with per-company links."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 5: At Risk — trigger engine off staging activity fields, suggestion b…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings Phase 5: At Risk — trigger engine off staging activity fields, suggestion banner+dot, panel (required owner, reasons, notes, book review), urgent banner, sortable table with inline status/notes."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 4: payments plumbing — env-config Stripe Payment Links with client_re…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings Phase 4: payments plumbing — env-config Stripe Payment Links with client_reference_id, test-mode mock checkout (token-scoped, audited), signature-gated Stripe webhook (503 until secret set)."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 3: lead Onboarding tab (customer link + plan panel + checkpoints acco…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings Phase 3: lead Onboarding tab (customer link + plan panel + checkpoints accordions + bookings timeline), encrypted token storage + link endpoint, meetings CRUD, Gold price flow."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 2: board page (columns, filters, drag+reason override, complete promp…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Onboardings Phase 2: board page (columns, filters, drag+reason override, complete prompt, staging pull button, stage-segment cards) + route + sidebar."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Onboardings Phase 1: migration 118 (5 tables), stage/plan config, slug+hashed-token ser…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Onboardings Phase 1: migration 118 (5 tables), stage/plan config, slug+hashed-token service, staff API (/crm/onboardings, scoped auth), public token-scoped embed API, staging.wequote pull (separate env), Robert docs."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Repair 541 (crmUi.tsx staged) + lead hero rev 2: booking buttons alone on row 1, chips+…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Repair 541 (crmUi.tsx staged) + lead hero rev 2: booking buttons alone on row 1, chips+Merge/Edit/Archive on row 2; clock wall hidden inside leads."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Repair 541: ScoreBadge className prop (crmUi.tsx) was part of the hero-chips change-set…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Repair 541: ScoreBadge className prop (crmUi.tsx) was part of the hero-chips change-set but missed the stage — prod build failed on TS2322."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Lead page: hero header + segmented stage bar + utility row; body reworked to top tab ba…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead page: hero header + segmented stage bar + utility row; body reworked to top tab bar with 80/20 content/details split, independent scrolling, Details facts card with live lead time."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Lead page: hero header + segmented stage bar + utility row; body reworked to top tab ba…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead page: hero header + segmented stage bar + utility row; body reworked to top tab bar with 80/20 content/details split, independent scrolling, Details facts card with live lead time."
    ]
  },
  {
    "date": "2026-09-28",
    "title": "Lead page: hero header (back · avatar+plus · name/contact · Book call/meeting), full-wi…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead page: hero header (back · avatar+plus · name/contact · Book call/meeting), full-width segmented stage bar, single utility row for chips/flags/actions."
    ]
  },
  {
    "date": "2026-09-24",
    "title": "roll Jesse 1.1 to everyone + treat WeQuote invoices as a product question (probe, don't…",
    "tags": [
      "AI"
    ],
    "bullets": [
      "roll Jesse 1.1 to everyone + treat WeQuote invoices as a product question (probe, don't escalate)"
    ]
  },
  {
    "date": "2026-09-24",
    "title": "no-ring pilot — np@wetech.cloud chats picked up silently, no team ring",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "no-ring pilot — np@wetech.cloud chats picked up silently, no team ring"
    ]
  },
  {
    "date": "2026-09-24",
    "title": "Jesse 1.1 much shorter — 150-token cap, less context, hard length rule",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse 1.1 much shorter — 150-token cap, less context, hard length rule"
    ]
  },
  {
    "date": "2026-09-24",
    "title": "Jesse 1.1 answer-first voice, piloted to np@wetech.cloud (overlay + email gate)",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse 1.1 answer-first voice, piloted to np@wetech.cloud (overlay + email gate)"
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Sync: a new/different WeQuote timezone counts as a change, so the meta merge runs for o…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sync: a new/different WeQuote timezone counts as a change, so the meta merge runs for otherwise-unchanged deals (was 41/1662 covered; the skip-unchanged fast path starved the new field)."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Lead timezone = WeQuote API timezone only (normalized); no phone/address guessing anywh…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead timezone = WeQuote API timezone only (normalized); no phone/address guessing anywhere; leads without one show no clock until the field arrives."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Jesse auto-takeover 20s -> 10s (sweep every 5s so it's honoured)",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse auto-takeover 20s -> 10s (sweep every 5s so it's honoured)"
    ]
  },
  {
    "date": "2026-09-23",
    "title": "WeQuote API country_code (alpha-3) + timezone fields: iso2Of conversion in sync/resolve…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "WeQuote API country_code (alpha-3) + timezone fields: iso2Of conversion in sync/resolver/prefill; webhook + sync verified pass-through (no rejection of the new fields)."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Clock wall: clock left + place/time/leads column, flags, hover/selected states, click-t…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Clock wall: clock left + place/time/leads column, flags, hover/selected states, click-to-filter Board & Leads by zone group; London pinned static left; label removed."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Clock wall: clock left + place/time/leads column right, flags, hover + selected states,…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Clock wall: clock left + place/time/leads column right, flags, hover + selected states, click-to-filter Board & Leads by zone group (shared tzFilter store)."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Clock wall: stacked layout (flag+bold name / time centre / lead count below) with count…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Clock wall: stacked layout (flag+bold name / time centre / lead count below) with country flags."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Simple CRM headers: subtitle sentences removed platform-wide (data moved to hover toolt…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Simple CRM headers: subtitle sentences removed platform-wide (data moved to hover tooltips); Board title+count+search on one line; clock wall enlarged."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Lead tz: API-sent timezone string is source of truth (normalized+validated, resolver fa…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead tz: API-sent timezone string is source of truth (normalized+validated, resolver fallback); 2h-cached offsets + minute clocks (no per-card timers); grouped wall-clock strip on all CRM pages via GET /crm/timezones."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Lead timezone resolved server-side (state → US/CA area code → dial code → country) as d…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead timezone resolved server-side (state → US/CA area code → dial code → country) as deal.localTz + prefill.tz; card clock ticks every second with seconds shown."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Lead local time: live clock chip on every board card + dual your-time/their-time line i…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead local time: live clock chip on every board card + dual your-time/their-time line in the booking modal (country → business timezone)."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "CS/at-risk population = the board's All Live column exactly (listDeals supplier rule: i…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "CS/at-risk population = the board's All Live column exactly (listDeals supplier rule: is_supplier=false OR mrr>0)."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "CS/at-risk population = All Live Companies list (wq_paid_customers active/vip joined on…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "CS/at-risk population = All Live Companies list (wq_paid_customers active/vip joined on wequote_id), mrr>0 safety net."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "CS live = mrr>0 OR wequote_meta status live/active; Calls tab excludes trial_expired_co…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "CS live = mrr>0 OR wequote_meta status live/active; Calls tab excludes trial_expired_contacted; widget alerts start 23 Sep (no backfill)."
    ]
  },
  {
    "date": "2026-09-23",
    "title": "Attention widget: category tabs (At Risk/Trials/Calls/Alerts/Completed) with trial + ca…",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Attention widget: category tabs (At Risk/Trials/Calls/Alerts/Completed) with trial + call-queue sources; CS live population widened to paying-or-real-plan."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Jesse hands off + goes silent immediately when a human takes the chat",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Jesse hands off + goes silent immediately when a human takes the chat"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "show live Jesse (AI) chats in My Chats -> Open like a normal open chat",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "show live Jesse (AI) chats in My Chats -> Open like a normal open chat"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "include Jesse (AI) in the Chat History monthly per-agent list",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "include Jesse (AI) in the Chat History monthly per-agent list"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Usage push: 202-accept + set-based bulk ingest (fixes the 504), one datapoint per accou…",
    "tags": [
      "Mobile"
    ],
    "bullets": [
      "Usage push: 202-accept + set-based bulk ingest (fixes the 504), one datapoint per account per UTC day with same-day replace, active_days clamp, overlap-safe 14d quote count, 13-month retention."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "full rollout — AI_RESPONDER_ALLOWED_DOMAINS=* + mobile ring-card spec (20s, all users)",
    "tags": [
      "Mobile",
      "AI"
    ],
    "bullets": [
      "full rollout — AI_RESPONDER_ALLOWED_DOMAINS=* + mobile ring-card spec (20s, all users)"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Call chase gated on Customer: Finished (defer at signup, start on status transition); a…",
    "tags": [
      "Widget"
    ],
    "bullets": [
      "Call chase gated on Customer: Finished (defer at signup, start on status transition); attention status changes notify the team as acknowledgeable items; widget opens on arrival."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "off-hours human-request -> chat shows in Missed (missed_at) + explicit 'ticket created'…",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "off-hours human-request -> chat shows in Missed (missed_at) + explicit 'ticket created' line"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Prior-demo match on signup (email-slug): auto-contacted, queue skipped, calm alert; 'al…",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Prior-demo match on signup (email-slug): auto-contacted, queue skipped, calm alert; 'already_demoed' outcome with no forced call/note. Mobile doc 15."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "hide notice-hours '3 messages' box when Jesse (AI) is handling the chat",
    "tags": [
      "Support",
      "Widget",
      "AI"
    ],
    "bullets": [
      "hide notice-hours '3 messages' box when Jesse (AI) is handling the chat"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "clear Jesse hand-back on ring card + notice flow never converts an AI-eligible chat",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "clear Jesse hand-back on ring card + notice flow never converts an AI-eligible chat"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "clear Jesse hand-back on ring card + skip notice overlap when Jesse handles",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "clear Jesse hand-back on ring card + skip notice overlap when Jesse handles"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Customer Success / at-risk population: successfully_signed_up AND mrr>0 — matches All L…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Customer Success / at-risk population: successfully_signed_up AND mrr>0 — matches All Live Companies; £0 sync artefacts excluded."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Jesse auto-takeover window 60s -> 20s",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Jesse auto-takeover window 60s -> 20s"
    ]
  },
  {
    "date": "2026-09-22",
    "title": "migration 117 ensures the Jesse agent row exists",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "116's Jesse insert was skipped by an isBaseTable guard on prod (migration still recorded), so 'Send to Jesse' / takeover had no agent to assign. 117 inserts it robustly (builds the row from existing NOT-NULL columns, no guard)."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Customer Success / quote-risk population = live customers only (successfully_signed_up).",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Customer Success / quote-risk population = live customers only (successfully_signed_up)."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "At-risk = no quotes 2 weeks (single rule); Customer Success rewritten simple + moved be…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "At-risk = no quotes 2 weeks (single rule); Customer Success rewritten simple + moved below Board; attention items get statuses + notes shared across surfaces. Migration 116."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Jesse behaves like an agent (ring-first, 60s takeover, Send to Jesse, off-hours)",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Jesse is a real assignable agent (migration 116). Normal hours: pilot chats ring the team first; unpicked after AI_TAKEOVER_SECONDS → Jesse takes over with the pickup notification. New 'Send to Jesse' action + endpoint. Escalation re-queues and rings, then Jesse resumes if unpicked. Off hours: Jesse picks up immediately, converts to a ticket (redirect line) on human-request/can't-answer. Jesse posts as an agent so it counts in reports."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Attention dock: bottom-edge anchored (horizontal drag only), panel opens upward within …",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Attention dock: bottom-edge anchored (horizontal drag only), panel opens upward within viewport, drag no longer triggers open."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Repair: commit the 515/517 pieces (touchpointsSummary, TouchDots icons, show drag-order…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Repair: commit the 515/517 pieces (touchpointsSummary, TouchDots icons, show drag-order + migration 111) that later deploys reference — fixes the prod build."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "Needs Your Attention dock: draggable/dockable widget fed by health (activity down), ado…",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "Needs Your Attention dock: draggable/dockable widget fed by health (activity down), adoption churn risk and CRM alerts; team-wide completions. Migration 115."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "paste/upload images + files in the AI Copilot (agent side)",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Composer gains paste/upload/drag with previews (parity with the chat box). Images",
      "+ PDFs are sent to the model as content blocks (vision); a pasted image bypasses the corpus gate so it's actually examined. Attachments persist (migration 114) and render on reload. claude.service accepts multimodal content."
    ]
  },
  {
    "date": "2026-09-22",
    "title": "start ring-timeout at escalation (queue_in_at=now)",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Escalated AI chats were instantly converted to missed 'team unavailable' tickets because the ring-timeout is measured from created_at, which is already old after the visitor's time with Jesse. Set queue_in_at at escalation so the agent gets the normal pickup window."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "try to help before transferring (no instant handover on first gate)",
    "tags": [
      "AI"
    ],
    "bullets": [
      "A gated retrieval (preamble like 'can I ask about X', or a vague question) no longer escalates immediately. Jesse invites more detail and tries again, and only hands over on a second failed attempt. Successful answers reset the counter."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "self-hosted Jesse avatar (external image was CSP-blocked)",
    "tags": [
      "Widget",
      "AI"
    ],
    "bullets": [
      "Add packages/widget/public/jesse-avatar.svg (served at /api/widget/jesse-avatar.svg) and default the persona avatar to that same-origin path so it actually renders.",
      "Overridable via AI_RESPONDER_AVATAR_URL."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "show active AI chats as open (not queued); no observing ding",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "/queue masks an active AI chat as an open chat handled by 'Jesse' (display only).",
      "useChatThread suppresses the per-customer-message tone while ai_state='active' so an agent observing an AI chat isn't dinged on every message."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "AI chats observable in queue but never ring (server-side mask)",
    "tags": [
      "CRM",
      "Support",
      "AI"
    ],
    "bullets": [
      "Revert the blanket queue exclusion (28) and instead present ai_state='active' chats as handled by the persona ('Jesse') in the /queue response: assigned_agent_id",
      "+ agent_name are masked (display only, DB agent_id untouched). The dashboard's existing 'skip assigned chats' alert logic then never rings them, even on a stale tab, while they stay visible for live observation. Escalated chats are not masked, so they ring as fresh arrivals."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "AI-active chats skip the human queue until escalation",
    "tags": [
      "CRM",
      "Support",
      "AI"
    ],
    "bullets": [
      "getQueue excludes ai_state='active' from the agent queue + ring poll, so Jesse handles the chat without it ever showing as a pickup or ringing. On escalation (ai_state='escalated') the chat re-enters the queue as a fresh arrival and rings.",
      "Server-side so a stale dashboard tab can't defeat it; ordinary chats and History are unaffected."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "hide widget 'connecting to an agent' banner for AI chats",
    "tags": [
      "Support",
      "Widget",
      "AI"
    ],
    "bullets": [
      "The embedded launcher creates the chat, so the widget never saw ai_active on the create response. Hide the waiting banner whenever a bot (Jesse) message is present, which covers both the launcher and direct-create paths."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "personalised greeting 'Hi <first name>, how can I help?'",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Greeting uses the visitor's first name when known, falls back to 'Hi, how can I help?' otherwise."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "no ring for AI chats, suppress widget 'connecting' banner, stop UNCLEAR clarify loop",
    "tags": [
      "Support",
      "Widget",
      "AI"
    ],
    "bullets": [
      "GlobalQueueAlerts: skip ai_state='active' chats (they don't ring/notify; still visible in the queue; ring only once escalated).",
      "POST /chats returns ai_active so the widget hides 'connecting you to an agent' while Jesse is handling the chat.",
      "Classifier biased hard to PRODUCT_QUESTION; UNCLEAR now attempts a grounded answer instead of a canned 'tell me more'."
    ]
  },
  {
    "date": "2026-09-21",
    "title": "visitor-facing AI first responder on the widget",
    "tags": [
      "Support",
      "Widget",
      "AI"
    ],
    "bullets": [
      "Greets/answers/deflects/escalates/closes eligible widget chats, grounded in the",
      "Copilot corpus (reuses copilot.retrieve + the same ANTHROPIC_API_KEY). Gated by",
      "FEATURE_AI_RESPONDER + AI_RESPONDER_ALLOWED_EMAILS (pilot) /",
      "AI_RESPONDER_ALLOWED_DOMAINS=* (full). Persona 'Jesse' is display-only.",
      "Migration 113 adds ai_state to wq_support_chats + wq_ai_responder_turns and rebuilds the chats view. Sweeps in jobs.service guard ai_state='active' so a live AI chat is never marked missed/auto-closed (C-1/C-2/C-3). Runbook:",
      "docs/AI-RESPONDER.md."
    ]
  },
  {
    "date": "2026-09-18",
    "title": "Qualification Gate Automation (Fi's PRD 1-3): auto-fill with provenance, live 0-100 sco…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Qualification Gate Automation (Fi's PRD 1-3): auto-fill with provenance, live 0-100 score + bands, <67% demo-booking flag with required reason + manager alert. Migration 112."
    ]
  },
  {
    "date": "2026-09-18",
    "title": "agent breakdown by company + split-screen transcripts",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Click an agent in the Monthly Report to see per-company time/chats for the month;",
      "click a company for a split-screen of that agent's chats with them as transcript cards. Adds /chat-history/agents/:id and /chat-history/agents/:id/companies/:alias."
    ]
  },
  {
    "date": "2026-09-18",
    "title": "ux(chat-history): drop the Agent time caption line",
    "tags": [
      "Support"
    ],
    "bullets": [
      "ux(chat-history): drop the Agent time caption line"
    ]
  },
  {
    "date": "2026-09-18",
    "title": "ux(chat-history): scrollable fixed-height agent + company lists",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Cap the Monthly Report's two lists and scroll within them so the page doesn't grow with many rows."
    ]
  },
  {
    "date": "2026-09-18",
    "title": "Monthly Report tab (time by month, per-agent, per-company)",
    "tags": [
      "Support"
    ],
    "bullets": [
      "New GET /chat-history/monthly (month totals, per-agent handling time + chats, per-company aggregates for the month). Chat History is tabbed and opens on the",
      "Monthly Report; Complete = the original company cards."
    ]
  },
  {
    "date": "2026-09-17",
    "title": "batch replay in rAF so chat messages aren't delayed",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Heavy rrweb replay ran synchronously in the socket handler, delaying other socket events (new chat messages) while co-browsing. Buffer mirror events and flush per animation frame so the handler returns instantly."
    ]
  },
  {
    "date": "2026-09-17",
    "title": "Visitor transcript modal is live: joins the chat socket room + 5s poll fallback — mobil…",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Visitor transcript modal is live: joins the chat socket room + 5s poll fallback — mobile-sent replies now appear without reopening."
    ]
  },
  {
    "date": "2026-09-17",
    "title": "Prominent stage pills on the lead screen; LeadKebab quick-actions menu on show + leads …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Prominent stage pills on the lead screen; LeadKebab quick-actions menu on show + leads rows (mark contacted / nurture / disqualify / call / email / archive)."
    ]
  },
  {
    "date": "2026-09-17",
    "title": "Leads + shows open as full screens from every click path (LeadRedirect shim, show card …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Leads + shows open as full screens from every click path (LeadRedirect shim, show card navigates, edit modal on show screen)."
    ]
  },
  {
    "date": "2026-09-17",
    "title": "visitor mobile from WeQuote account + tap-to-call",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "/chats/:id/account returns person.phone (wq_crm_contacts by visitor_email; mobile",
      "?? phone; falls back to customer phone). Chat info sidebar shows a Mobile row with a tel: call link. Documented person.phone in MOBILE-API for the mobile app."
    ]
  },
  {
    "date": "2026-09-17",
    "title": "Show + lead full screens (stage strip, back bars), leads show-filter, 5-route touchpoin…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Show + lead full screens (stage strip, back bars), leads show-filter, 5-route touchpoints card with Brevo mailing-list truth. Migration 110."
    ]
  },
  {
    "date": "2026-09-17",
    "title": "stop white-screen crash when editing the time",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "An empty/partial time made new Date(...).toISOString() throw (Invalid Date), crashing the modal. Build the ISO only from a valid HH:MM (null otherwise) and guard save() for a missing start time."
    ]
  },
  {
    "date": "2026-09-16",
    "title": "everyone can switch Support/Dev + Profile reachable in Dev",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Retire the dev-only hard lock (no account is trapped on one side); always show the Support Mode button on the Dev board. Add a Profile button to the Dev top bar that switches to Support and opens /profile."
    ]
  },
  {
    "date": "2026-09-10",
    "title": "Bad-number outcome stamps first_contact_at (contact obligation resolved, engagement unt…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Bad-number outcome stamps first_contact_at (contact obligation resolved, engagement untouched) on both outcome paths; retro repair in deploy."
    ]
  },
  {
    "date": "2026-09-09",
    "title": "Baileys gateway: getMessage retry-receipt hook + stored send protos — fixes permanent '…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Baileys gateway: getMessage retry-receipt hook + stored send protos — fixes permanent 'Waiting for this message' on new leads."
    ]
  },
  {
    "date": "2026-09-08",
    "title": "Email matching: duplicate-lead tie-break (live/newest deal wins), auto-drain the review…",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Email matching: duplicate-lead tie-break (live/newest deal wins), auto-drain the review queue, sibling-deal union on the Emails tab."
    ]
  },
  {
    "date": "2026-09-08",
    "title": "Email identity map widened: company-wide contacts + company domain/website columns seed…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Email identity map widened: company-wide contacts + company domain/website columns seed the domain matcher; self-heal re-pull covers them."
    ]
  },
  {
    "date": "2026-09-08",
    "title": "Email sync self-heal: re-seed identity map each cycle + targeted Gmail re-pull for new …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Email sync self-heal: re-seed identity map each cycle + targeted Gmail re-pull for new leads; daily mismatch alerts; /crm/email/coverage report."
    ]
  },
  {
    "date": "2026-09-08",
    "title": "Lead avatars beside names on planner Leads tab + Shows/Events list (logo → uploaded ima…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead avatars beside names on planner Leads tab + Shows/Events list (logo → uploaded image → initial placeholder)."
    ]
  },
  {
    "date": "2026-09-08",
    "title": "Lead Images tab + uploaded avatars (WeQuote logo wins once linked) via deal.logoUrl eve…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Lead Images tab + uploaded avatars (WeQuote logo wins once linked) via deal.logoUrl everywhere; planner Leads tab opens the lead. Migration 109."
    ]
  },
  {
    "date": "2026-09-07",
    "title": "Event Planner: normalise event dates to yyyy-mm-dd over the wire; defensive date format…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Event Planner: normalise event dates to yyyy-mm-dd over the wire; defensive date formatting — fixes Invalid date / blank start date after refresh."
    ]
  },
  {
    "date": "2026-09-07",
    "title": "Event Planner: pre-existing customers worth £0 to an event (Won/pipeline/earned), break…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Event Planner: pre-existing customers worth £0 to an event (Won/pipeline/earned), breakeven only when actually earned, earnings row as full stat cards."
    ]
  },
  {
    "date": "2026-09-07",
    "title": "Event Planner: Won split from pipeline, company dedupe, Total Earned / Left to Breakeve…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Event Planner: Won split from pipeline, company dedupe, Total Earned / Left to Breakeven / Profit over Breakeven pills, details bar under tabs; undefined metric cards removed."
    ]
  },
  {
    "date": "2026-09-07",
    "title": "Event Planner v2: master-detail split — events left, permanent tabbed panel (Overview/E…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Event Planner v2: master-detail split — events left, permanent tabbed panel (Overview/Expenses/Leads) right; no more inline expansion."
    ]
  },
  {
    "date": "2026-09-07",
    "title": "Event Planner: per-lead annual pipeline values (size-band anchored on real customers), …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Event Planner: per-lead annual pipeline values (size-band anchored on real customers), budget + itemised expenses with attachments, card/list views inline-expanding. Migration 108."
    ]
  },
  {
    "date": "2026-09-04",
    "title": "Platform: on-call agents (nl, np, rb, info, jc, lr) keep the incoming-chat ringer + pic…",
    "tags": [
      "Support",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-04",
    "title": "Dev Board: Release Notes edit/delete per entry (internal only) + linked unpublish from …",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-04",
    "title": "Dev Board: Release Notes embed — per-route CSP override so the inline filter/pagination…",
    "tags": [
      "CRM",
      "Widget",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-04",
    "title": "Dev Board: Release Notes multi-module + pagination — publish popup picks several module…",
    "tags": [
      "CRM",
      "Widget",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-04",
    "title": "Dev Board: Release Notes multi-module + pagination — publish popup picks several module…",
    "tags": [
      "CRM",
      "Widget",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-04",
    "title": "Dev Board: Release Notes multi-module — publish popup picks several modules (chips), pe…",
    "tags": [
      "CRM",
      "Widget",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-04",
    "title": "Dev Board: one-shot import of the 25 dev-request cards from Lee's sheet — bands, priori…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-03",
    "title": "Dev Board: Release Notes polish — timeline rail with brand-red dots, colour-coded modul…",
    "tags": [
      "CRM",
      "Widget",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-03",
    "title": "Dev Board: Release Notes — publish pop-up (module/title/date/description/image), intern…",
    "tags": [
      "CRM",
      "Widget",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-03",
    "title": "Dev Board HOTFIX: Roadmap blank page — stage lane items sent undefined into blockW.",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Only t==='block' items use block width; stage items are card-width.",
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-03",
    "title": "paginate Platform Updates at 50 per page",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Prev/Next + 'Showing X-Y of N'; resets to page 1 on filter change and scrolls to top on page change."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "draggable during active chat via a slim top grip",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "The launcher header (drag handle) is hidden once the iframe chat is active, so dragging stopped working mid-chat. Add an always-visible slim grip at the top of the window as a drag point (works for visitor mouse and agent control)."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "chat window drag wedged after a control session",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Use permanent, flag-guarded document listeners for the window drag (any mouseup clears state) and have the agent send pointerup if control ends mid-drag, so dragging keeps working after screenshare/control."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "ux(cobrowse): move 'Offer screen share' to composer with a label",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Was an unlabelled icon in the header; now a labelled pill in the composer toolbar next to Invite to whisper, separate from Start co-browse / Request control."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "draggable chat window + drag-capable dual control",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Chat window draggable by its header (detaches from the pill). Control now streams pointer down/move/up so the agent can drag (incl. the chat window) and tap→click;",
      "relax the control guard so it can reach the widget (Stop banner still protected)."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "control scrolling (inner containers) + banners on the right",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Send cursor position with wheel so the visitor scrolls the element under it (nearest scrollable ancestor), not just the window. Move visitor co-browse banners to the right, clear of the left-docked chat widget."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "raise maxHttpBufferSize to 10MB (co-browse snapshot > 1MB)",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Default 1MB made the server close the connection on any message over it — the co-browse rrweb FullSnapshot of a real page exceeds 1MB, causing the visitor socket to flap ('transport close' ~1/s) and the snapshot to never arrive (blank view). Non-restrictive change to the shared Socket.IO server."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "resume recording across navigation, allow restart, lighter stream",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Resume rrweb recording when the visitor (re)loads a page mid-session so the agent follows navigations; clear a stale session on Start so restart works; add rrweb sampling + slimDOM + 30s checkout to reduce volume and enable recovery; reset control on visitor (re)join."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "raise rate cap + throttle snapshot requests (rate-kill)",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Sessions ended with reason 'rate' as control started: real FullSnapshots plus per-agent-join re-requests (multiple tabs) exceeded the 300 KB/s demo cap. Raise to 4 MB/s over a 10s window and throttle snapshot requests to 1/3s per chat."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "visitor socket polling-only — stops ~1.5s websocket flap",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Logs showed every drop was 'transport error' on websocket for the visitor's cross-origin connection, which lost the rrweb snapshot (blank view) and missed start/stop events (stuck banners). Use long-polling only with no upgrade."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "sync visitor state on rejoin + log disconnect reason",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Clear stale visitor banners when a (re)joining visitor has no session / no active control (Stop banner was persisting because the end event was missed mid-flap).",
      "Also log socket disconnect reason + transport to diagnose the ~1s flapping."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "re-send FullSnapshot on (re)join — fixes blank view",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Visitor socket flaps right after start lost rrweb's only FullSnapshot (snapshotKB=0), leaving the viewer blank. Server now requests a fresh snapshot when a viewer (re)joins and shortly after the session goes active; the launcher re-emits a snapshot on request and on its own reconnect (with a restart-record fallback for rrweb builds without takeFullSnapshot)."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "reconnect grace + stop rebuilding view on replay hiccups",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "A transient socket drop right after start was ending the session immediately;",
      "add a ~12s grace where the same role can rejoin and keep the session. Also stop rebuilding the replayer on every rrweb throw (blanked the view); log + continue."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "stop rebuilding the mirror on replay hiccups (blank view)",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "The 483 self-heal rebuilt the replayer on any rrweb throw, blanking the view and destabilising the session. Revert to logging + continue; keep the manual Refresh button for genuine recovery."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "control mis-click, re-prompt, self-heal, header declutter",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Move control controls away from End co-browse; always re-prompt the visitor on control re-request (fixes Allow doing nothing); self-heal a blank/frozen mirror by rebuilding from the buffered snapshot + a manual Refresh; block replayed clicks from hitting the co-browse banner/widget; compact the Offer pill; add control request/consent + end-reason logs."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "one-click 'Offer screen share' pill",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Sends a pre-written, consent-asking message inviting the visitor to a screen share (view-only first, stoppable, control asked separately). Shows next to",
      "Start co-browse on live open chats where co-browse is enabled."
    ]
  },
  {
    "date": "2026-09-03",
    "title": "exclude auto_closed chats from the Missed bucket",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Missed matched missed_at IS NOT NULL, so a missed-then-auto-closed chat showed under both Missed and Auto Closed. Exclude status='auto_closed' from the missed query (unless explicitly requested), which also fixes the Missed count."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: My Board card sizing fix — min-heights + containment; no more collapsed stri…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: My Board sections as ovc cards — same proportions as the Completed card, sta…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: roll back 484/485 — My Board returns to the pre-declutter layout (481 state).",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: My Board stat strip — one card, four fixed equal cells, scale-proof numerals.",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: My Board declutter — every section is a dedicated panel card with stable emp…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: grouped Priority flow — Committed (by projected completion) → Design → Now →…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Fixes interleaved sections/repeated headers/stray rank numbers; position dropdown blocked on committed (roadmap-ordered); suggestBand advisory chip.",
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Phase 2 dual control (clicks + scroll only)",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Agent can request control during an active view session; visitor gives a second consent; agent clicks + wheel are replayed on the visitor page (elementFromPoint",
      "+ real mouse events / scrollBy). Amber 'being controlled' banner + Stop on the visitor; Esc/Release on the agent. Server hard-allow-lists click/scroll only — no keystrokes. Audit lines on control start/end."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "collapsed nav re-open handle sits at top, not mid-screen",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "The re-open chevron was pinned to top-1/2 (screen middle); move it to top-4 to match the nav's collapse button and the other collapse/expand toggles."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "collapsible chats list + cleaner co-browse workspace",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Collapse the chats list to a slim counts rail (categories + live counts); hide it entirely during co-browse so it's just the visitor screen + chat. Collapse/ expand chevrons for the list and the account sidebar now share the same vertical position. Composer toolbar wraps instead of squishing at narrow width and hides the Enter hint when compact."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: My Board — Overview-style Completed card (per dev, top right) + Up next belo…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "declutter chat header in docked side-panel mode",
    "tags": [
      "Support"
    ],
    "bullets": [
      "While co-browsing, the chat docks to ~420px but the header kept rendering all action buttons, which overlapped. Hide the heavy buttons (QuickBook, Ticket, timer, controls, Close, observer badge, header End) when docked; the viewer's own header carries End + Pop out. Everything returns when co-browse ends or is popped out to its own window."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board v2 Phase 4: My Board (ADDENDUM-PRD §4) — completes the v2 handover.",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Per-login default with manager switcher; isMine incl. stage assignees;",
      "tiles + Working-on-now (hold/tick) + same-day/this-week + Up next +",
      "Completed. §72/§73 ported; suite 528 green.",
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board v2 Phase 3: the Schedule action (ADDENDUM-PRD §3).",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Schedule modal (dev + pinned start + required estimate + completion preview;",
      "per-stage for staged cards) surfaced from the card read view, pool kanban cards, Calendar coming-soon, Roadmap Now rows and Priority rows. §71 ported;",
      "suite 515 green.",
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board v2 Phase 2: staged delivery (ADDENDUM-PRD §2).",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Stage model + derived/locked umbrella estimate + deadline guard; per-stage scheduling with handoff dependency AND lane packing; stage bars on Calendar and Roadmap; inline click-to-edit stage editor; stage-complete flow with prompt to Ready to Test. phase8 harness (30 checks); suite 500 green.",
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board v2 Phase 1: Backlog → Now/Next/Later bands (handover ADDENDUM-PRD §1/§5/§6).",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Pool statuses + one-shot backlog→later migration; by-band contiguous numbering; band moves via status control; within-band position dropdown;",
      "insert-by-score; Organise pool; band filter; Now-only coming-soon and unscheduled panels. 470 checks green.",
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "serialise all JSON columns on save",
    "tags": [
      "Widget"
    ],
    "bullets": [
      "The PUT only stringified a whitelist of JSON fields; quick_actions was omitted, so its array was inlined as [object Object] — a SQL syntax error that failed the entire UPDATE. Every Widget Settings save (incl. features.cobrowse) silently reverted. Serialise any object/array value generically before the UPDATE."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: Waiting on Customer Review column (after dev, before testing); waiting cards…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "add missing features JSON column (migration 105)",
    "tags": [
      "Widget"
    ],
    "bullets": [
      "The widget-config routes read/write a features field and the admin Widget",
      "Settings page saves features.cobrowse (the co-browse gate), but no column ever existed — so any save including features failed with 'Unknown column features' and silently reverted the whole save. Add a nullable JSON column, backfilled {}."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Phase 1 — manual, view-only, consented co-browse",
    "tags": [
      "CRM",
      "Support",
      "Widget"
    ],
    "bullets": [
      "Agent presses 'Start co-browse' (manual, never auto); the visitor consents on their page; the dashboard swaps to a large live viewer with the chat docked on the side. Consent-gated relay, audit system-messages on start/end, per-session rate cap + global concurrent cap. Double-gated by FEATURE_COBROWSE (env) and the",
      "Widget Settings features.cobrowse toggle. Removes the Phase 0 spike page."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Dev Board: restore Design + Bug ticks on Add Feature (single Flags row) and Needs Revie…",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "Claude-Session: https://claude.ai/code/session_01RfR8LiZrV8uQMZtApfFh5Z"
    ]
  },
  {
    "date": "2026-09-02",
    "title": "buffer + replay snapshot to late-joining viewers",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Viewer saw only a moving cursor on a blank canvas: it joined after the visitor's FullSnapshot was relayed, so rrweb had no DOM to build. Server now buffers per-chat events since the last meta/snapshot (reset on navigation, capped at 4000) and replays them to any agent viewer on join."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "self-host rrweb + socket.io (CSP blocked the CDN)",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Spike hit script_blocked(rrweb): embedding-page CSP forbids the jsdelivr",
      "CDN. Serve rrweb + socket.io from our origin under /api/widget/* (same origin already serving chat-launcher.js, so allowed everywhere the widget works). Launcher + spike viewer load them same-origin. Libs fetched onto the server by the deploy (kept out of git)."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "server-visible stage breadcrumbs",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Launcher pings /api/cobrowse-spike-ping at each spike stage (armed, chat_ready, recording; script_blocked/socket_error/libs_missing on failure); flag-gated GET endpoint logs them so we can trace the customer side without their console."
    ]
  },
  {
    "date": "2026-09-02",
    "title": "Phase 0 measurement spike (double-gated, inert by default)",
    "tags": [
      "CRM",
      "Support",
      "Widget"
    ],
    "bullets": [
      "rrweb recorder in the launcher (localStorage wq_cobrowse_spike gate, all inputs masked) -> byte-counting socket relay on cobrowse:<chatId> rooms (registered only when FEATURE_COBROWSE=true) -> hidden /cobrowse-spike dashboard page with live mirror + snapshot/KB-per-second stats. No payload parsing/storage/logging; rooms fully separate from chat/queue.",
      "Zero behaviour change with flags off. Phase 1 (focus-mode co-browse) proceeds on these measurements."
    ]
  },
  {
    "date": "2026-09-01",
    "title": "Dev Board: simulate button removed; design tick hidden on add/needs-review; rank badge …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: simulate button removed; design tick hidden on add/needs-review; rank badge → move-to-position; Add Feature uses CRM picker."
    ]
  },
  {
    "date": "2026-09-01",
    "title": "Dev Board: fixed-width card action block — identical button layout regardless of title …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: fixed-width card action block — identical button layout regardless of title length."
    ]
  },
  {
    "date": "2026-09-01",
    "title": "Dev Board: Bug checkbox on the card read view (next to Design required) — no edit mode …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: Bug checkbox on the card read view (next to Design required) — no edit mode needed."
    ]
  },
  {
    "date": "2026-09-01",
    "title": "Dev Board: start date, deadline and progress editable in place on the card read view.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: start date, deadline and progress editable in place on the card read view."
    ]
  },
  {
    "date": "2026-09-01",
    "title": "Dev Board: compact filter panel — sections over 3 options become dropdowns; Module mult…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: compact filter panel — sections over 3 options become dropdowns; Module multi-select via add-dropdown + chips."
    ]
  },
  {
    "date": "2026-09-01",
    "title": "Dev Board: Module field (8 WeQuote areas) — kanban chip, click-to-edit, required on new…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Blank allowed only on imports; 5 new phase2 checks."
    ]
  },
  {
    "date": "2026-09-01",
    "title": "Dev Board: side filter panel on the Priority list + requested-by filter.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Products-page-style right panel (radio sections incl. searchable Requested by), removable active-filter chips, funnel toggle with count, per-user open state; core reqBy filter with 5 phase2 checks."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "launcher tab + chat window scale with the viewport",
    "tags": [
      "Support",
      "Widget",
      "Mobile"
    ],
    "bullets": [
      "Tab is fully em-based off one clamp(10px, 0.85vw, 13px) driver so icon, text, padding and radius scale together on resize (floor on small windows instead of blocking the UI, gentle cap on large). Chat window switches from fixed 380x520 to clamp(300px,26vw,430px) x clamp(380px,62vh,600px) with viewport max guards; mobile fullscreen unaffected."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: re-centre the open card's row when the Focus detail closes (and opens) — no …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: re-centre the open card's row when the Focus detail closes (and opens) — no more lost scroll position."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: fix modal focus-loss on typing; free-type company picker with CRM matching.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "ModalWrap hoisted (remount-per-keystroke bug); CustomerPicker suggests paid customers + CRM leads + board names; picked CRM entries store crmId/crmKind on the request; /devboard/customers endpoint; QuickEdit popover uses same sources; 3 new phase1 checks."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: resolve-button spacing — inline-flex group with explicit 10px gap (display:c…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: resolve-button spacing — inline-flex group with explicit 10px gap (display:contents dropped)."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: pop-up header — 10px button gaps; empty rank pill no longer renders.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: pop-up header — 10px button gaps; empty rank pill no longer renders."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: button wording — Merge / Add to list / + Request; duplicate Archive dropped …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: button wording — Merge / Add to list / + Request; duplicate Archive dropped from pop-up."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: card pop-up tidy — fixed buttons, contained inputs, section dividers.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: card pop-up tidy — fixed buttons, contained inputs, section dividers."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: UI harmonization layer — one scale for buttons, pills, inputs, toolbars.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Sizes, padding, radii and vertical alignment normalized; no placement or colour changes."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: notification settings icon gear → bell (too sun-like next to dark-mode toggle).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: notification settings icon gear → bell (too sun-like next to dark-mode toggle)."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: Needs Review cards open the standard read view; edit only via pencil.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "ReviewModalBody retired; resolve bar joins ReadView for review cards;",
      "quick-edit chips added to the pop-up read view for all cards."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: Priority-list status filter — every kanban column selectable.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "ToolbarFilters gains status (backward-compatible); dropdown in the Priority toolbar; 5 new phase2 checks."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: global search bar on every screen.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "core/search.ts (haystack + ranked multi-word search, 12 harness checks) + top-bar SearchBar with keyboard navigation; results open the card pop-up."
    ]
  },
  {
    "date": "2026-08-28",
    "title": "Dev Board: quick-edit chips on all cards — priority, status, est time, customers, dev, …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Anchored dropdowns (search on customers + dev, date picker for deadline);",
      "same mutations as the edit screen so all gates and stamps apply."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "launcher tab flush to the bottom-left corner, top-right edge rounded",
    "tags": [
      "Widget",
      "Mobile"
    ],
    "bullets": [
      "left: 0 / bottom: 0 (was 56px offset), border-radius 0 10px 0 0 so only the top-right edge is rounded; mobile matches. Size and behaviour unchanged."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "launcher tab compact — 36px tall, icon beside text, 56px offset",
    "tags": [
      "Support",
      "Widget",
      "Mobile"
    ],
    "bullets": [
      "Per feedback on the bottom tab: height cut ~55% (80 -> 36px, 40 on hover), icon + 'Chat with us' in a row instead of stacked, moved further left (96 -> 56px). Mobile 32px/16px."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "launcher becomes a bottom tab ('Chat with us')",
    "tags": [
      "Support",
      "Widget",
      "Mobile"
    ],
    "bullets": [
      "Replaces the 60px round floating button with a 118x80 rectangular tab stuck flush to the bottom edge, offset 96px from the left wall so it clears the WeQuote platform's white side menu. Chat icon + 'Chat with us' label, rounded top corners, hover lift, close-icon swap while open, badge on the tab corner, smaller variant on mobile. Window geometry unchanged."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: restore the 27 demo cards (pristine seed state) alongside the Trello import.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "One-shot guarded by dev_board_meta.demo_restored; id-safe (skips existing)."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: dark mode full coverage — navy headings, all chip tints, residual surfaces.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Stylesheet-wide audit until zero uncovered rules: light backgrounds and dark text remapped; pastel chips become same-hue dark tints."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: dark mode pass 2 — audit-driven fixes for missed light surfaces.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Focus open-card panel, Overview/Archived cards, roadmap lanes, modal inputs, action buttons, weekend shading, late cards, export modal chrome."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: one-time Trello import (263 real cards), demo data cleared.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Requesters extracted from card names into requests (default 2026-06-01);",
      "15 long names simplified with checklists; bugs flagged; labels → initiative;",
      "statuses/devs mapped; guarded by dev_board_meta.trello_imported."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: dark mode (per-user moon/sun toggle) + Focus split-scroll.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Dark theme layer over every view with accent colours preserved; preference in localStorage per agent. Focus list and open card scroll independently with overscroll containment."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: Focus list and open card are independent scroll columns.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "The sticky detail pane shared one scroller with the list, so hovering the edit side still scrolled the list and chained to the page at the end. Both columns now scroll separately with overscroll containment."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: typed start dates pin (roadmap-spec) — same-day tasks hold their day.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "setDate('start') sets pinnedStart (cleared when the start is cleared); the engine keeps pinned cards on their date and surfaces overlaps as conflicts;",
      "the Calendar stacks same-day bars. Harness: pin-on-type + same-day trio checks (phase1 90, phase4 49)."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: email corrections + calendar plotting fix.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev-column landing now emails Natalie only ('development has begun on X — on",
      "<Dev>'s board'); assignment emails the assigned person with a warm 'assigned to you' note (+deadline/estimate); five stage toggles in settings; human copy across review/priority/live. Calendar/Roadmap: datedCard relaxed to owner + estimate + (deadline OR start) so start-dated cards plot without a deadline;",
      "coming-soon copy updated. Harness 397 green; both packages tsc clean."
    ]
  },
  {
    "date": "2026-08-27",
    "title": "Dev Board: stage-based email matrix.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Needs Review → sign-off list; Priority List entry (from review/ideas) → everyone; a dev's Kanban column → that dev; Live → everyone incl. non-devs.",
      "One email per stage transition, detected server-side by payload diff; sends via the platform Gmail sender; recorded on the card; four stage toggles + sign-off list in the settings gear (server-stored). Supersedes the assigned/status/live trigger set."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: the active view survives reloads (persisted per user).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: the active view survives reloads (persisted per user)."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: cards keep natural height in scrolling columns (fix squash).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "overflow:hidden from the containment audit zeroed cards' automatic min-height, letting flex columns compress them to fit. Kanban cards + Focus rows are now flex:0 0 auto — columns scroll again."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: collapsible Kanban columns, per user.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Collapse chevron per column header; collapsed = slim vertical strip with label",
      "+ count, click to expand, still a valid drop target (design gating respected).",
      "Choice stored per logged-in agent in the browser — one user's collapse never affects another, and each layout is remembered."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: Natalie off the dev roster (migration 104).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "is_dev cleared for nl@wetech.cloud — her Kanban column, Calendar row, Roadmap lane and assignee entry are removed together (all roster-driven); cards in her column / assigned to her return to Backlog / unassigned. Account + access + intake-alert recipient unchanged."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: card containment audit — no content bleeds past card borders.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Chip/pill rows wrap (dv-row-sub, lc-right, kc-head, ovx-mini-row, cmp meta, link rows); flex children get min-width:0; card shells clip (dv-row, card, rm-card/row/urow, ovx minis, cmp-card, merge candidates, comments); long unbroken words break in titles/previews/notes; the pop-up request table scrolls horizontally instead of stretching. Fixes the Priority List bleed."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: title clears the collapse chevron when the nav is collapsed.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Dev Board: title clears the collapse chevron when the nav is collapsed."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: white chrome, icon set, mode bar removed (Lee, 26 Aug).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "The Dev-Mode header strip is gone for everyone; Support Mode moves into the board's top bar beside + Add Feature (hidden for dev-only accounts). Side nav and top bar go white (dark text, light hover, blue active; logo re-inked navy;",
      "grey badges); the collapse chevron sits on the nav's top-right edge. Every emoji replaced with a dependency-free inline-SVG icon set that inherits each control's colour. tsc clean; harness 395 green."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: the real eight-dev roster becomes the Kanban columns and lanes.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Migration 103: is_dev for rb/yk/sm/rt/np/lr/cc/nl@wetech.cloud; board dev ids are the email local part (stable slugs); legacy demo-card ids remapped (robert→rb, yadhu→yk, rizwan→rt, sreya→sm, leenithish→np). setDevRoster derives slug ids from the roster emails (agent-<id> fallback). All dev-driven",
      "UI (columns, lanes, dropdowns, donut, filters) is already dynamic and picks the eight up on load. Harness 395 green; both packages tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: dev-only accounts (rt@, yk@, sm@, cc@wetech.cloud).",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Migration 102 adds dev_only to agents (view rebuilt, 063 pattern) and flags the four accounts. dev_only rides in the JWT + login response. Dev-only users are locked to dev mode: land on /dev at login, mode switch to Support refused, support routes bounce to /dev, and the Dev-Mode white top bar (with the",
      "Support Mode button) is not rendered for them at all. All other users keep both modes unchanged. API + dashboard tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board: scroll containment — nav and panels static, only content scrolls.",
    "tags": [
      "CRM",
      "Widget"
    ],
    "bullets": [
      "The reference sizes itself as a full page (min-height:100vh; views at calc(100vh − 54px)), which overshoots inside Dev Mode's header and made the whole embed scroll. New structural containment layer: shell pinned to the available height; side nav + top bar + toolbars fixed; panel views scroll inside their cards (ovc bodies / roadmap lanes / calendar grid / kanban columns); list views scroll the content region with the Focus card sticky.",
      "DevMode's outer main is overflow-hidden. No visual redesign."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 7: Completed/Live + announce, customer roadmap export, Ideas.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Completed page: scoped analytics (shipped / quick wins / on-time / announced, by-dev donut, avg dev-days per effort tier vs estimate) + the announce workflow (announce to requesters / publish to updates page / WhatsApp / not-needed with undo; announced = announce+publish, handled counts dismissals). Customer roadmap export from the Roadmap toolbar: month-grouped Coming up / Recently released preview with range presets, include-released, per-card hide/show, customer-facing names only, print + standalone-HTML download. Ideas board:",
      "capture, similar-check, promote→Backlog, archive; excluded from the pipeline everywhere. Every reference view is now live. Harnesses",
      "84+88+50+33+43+31+26+39 = 394 green; tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 6: the Overview.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Needs-Attention tiles deep-linking into the Priority List with a one-visit category filter (manual filters sticky, lifted into shared state per the reference); the Completed by-dev donut + counters with month/year period filter; Working-on-now (2 in design + top card per active dev, with checkpoints); Top 8 Priorities; the Needs-Review list. Cards open the shared pop-up and review resolves from the Overview stay on the Overview. Harnesses",
      "84+88+50+33+43+31+26 = 355 green; tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 5: the Calendar.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Day/week/month timeline on the shared schedule: month bands, ISO week numbers, weekend/block-out shading, today line, per-dev rows with next availability, the",
      "Design row (design start → deadline) and gated placeholders for in-design cards. Same-day sub-day cards stack into sub-rows. Drag to move (snap + pin), edge-drag to resize (re-derives the working-day estimate + effort), drop on another dev to reassign (pin at drop) — click-with-no-movement opens the pop-up. Coming-soon side panel per dev in suggest-score order. Harnesses",
      "84+88+50+33+43+31 = 329 green; tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 4: the Roadmap and its scheduling engine.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "computeSchedule ported byte-for-byte: per-dev sequential working-day flow (weekends + block-outs skipped), forward-only cascade from the lane anchor, fixed deadlines, pins with conflict detection, the design-completion gate, and fractional day-packing (sub-day cards share a day; full-day cards never start on a part-used day). estCompletion derived on every client and surfaced from",
      "Design Complete onward. Roadmap view: build-order lanes under per-lane month bands, coming-soon zone, block-out tiles + manager with chips, pin toggle, collapse cards/lanes, Re-tidy, drag-reorder and drag-assign from the",
      "Unscheduled panel. Issues & actions: At risk / Blockers / Conflicts / Accepted risks. Harnesses 84+88+50+33+43 = 298 green; tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 3: Needs Review, intake, and the real alert email.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Needs Review master–detail (intake line, similar-count, resolve bar: add to dev / merge / archive; simulate-chat demo kept). Merge carries demand + notes into the target and removes the review item; resolving navigates to the card in Focus. + Add Feature form routes to Needs Review with requester seeding and effort preview. Archived view with required reason + Restore. Pop-up gains the",
      "Needs-Review (resolve bar top-right) and Archived variants. REAL intake alert:",
      "needsreview card creation emails the sign-off group via the platform Gmail sender (recipients in dev_board_meta intake_alert_recipients, default nl@wetech.cloud); failures never block the write; alertEmailedTo records the recipients. Harnesses: 84+88+50+33 = 255 green; both packages tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 2: Priority List + the suggested-priority engine.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Focus (master–detail, shared read/edit inline) + Grid (expand-in-place edit panel); filters incl. bugs + due-date set; sorts incl. Suggested. The triage engine ported verbatim: 0.4·priority + 0.4·demand(cap 5, falls back to the priority tag) + 0.2·effort; committed band (Design Complete onward, roadmap order) above the score-ordered triage backlog; blockers float; pins lock slots with nudges and reflow; apply-with-undo and reset; per-card score explainer + help modal; drag-reorder in Priority sort only (Suggested refuses, points to pins). Pop-up gains the suggest chip + blocker/pin actions. Harnesses: p0 84, p1 88, p2 50 = 222 green; tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 1: cards, the shared pop-up, and the Kanban board.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "The shared card pop-up (read-first, in-place edit, two columns): rank badge,",
      "BUG: prefix, pills, design-required toggle, meta grid, phase-aware progress with the shared cardStatus risk chip, checklist gating Live, links, Notes &",
      "Request-Details tabs (comment author = the real logged-in agent; request table with chase log + history), source line; actions incl. Add request, Hold/Resume,",
      "Mark-as-Live (confirmed + checklist gate), Archive-with-reason + restore.",
      "Edit panel reproduces editPanelHtml's stage-based field visibility (§5.2).",
      "Kanban: full column set incl. Testing Complete and per-dev lanes; drag runs the status engine (design gate w/ dimmed columns, checklist-before-Live, dev assignment + start stamp, stash/restore, on-hold, completedOn stamp/clear);",
      "LIVE cards show the simplified shipped state; ideas excluded. Core ported:",
      "working-day maths, activePhase/statusDisplay, cardStatus + designDevRisk, checklist, request counting/groups/chases, customer labels, all §5 mutations.",
      "Stylesheet regenerated with clean scoping. Harnesses green: phase 0 (84) + phase 1 (88) = 172 checks; dashboard tsc clean."
    ]
  },
  {
    "date": "2026-08-26",
    "title": "Dev Board rebuild Phase 0: server foundations + shell (handover PRD).",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Migration 101: dev_board_cards (JSON payload, mirrored status/dev, audit cols), dev_board_blockouts, dev_board_meta, and is_dev on agents (063 view-rebuild pattern, default false). /api/devboard: board GET (seeds the prototype's 27 demo cards on first-ever load; returns cards + blockouts + the is_dev roster), card create/whole-card update/delete, blockout create/delete — authenticated, updated_by recorded. Dashboard: Dev Mode mounts the rebuilt Dev Board shell — the reference side nav with live badges, the reference stylesheet scoped under",
      ".wq-devboard, Atkinson Hyperlegible — loading real board data; views land phase by phase. Core ported to TS: full card schema + migrate() defaulting,",
      "TIME_OPTS/calcEffort (Quick-win tier), statuses incl. Testing Complete + Ideas, and a dynamic dev roster (prototype's five until agents are flagged). Phase-0 harness green: 84 checks porting verify §1/§2/§14/§18/§60/§64/§67 + roster dynamics. Both packages tsc-clean."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Funnel pulse: speed/gates/adoption condensed to one chip strip on the Task Dashboard; r…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Funnel pulse: speed/gates/adoption condensed to one chip strip on the Task Dashboard; removed from Analytics."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Board: plain trial card handles reactivated-trial fields (undefined/undefined Days fix)…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Board: plain trial card handles reactivated-trial fields (undefined/undefined Days fix) + honest no-dates fallback."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Latest-first everywhere: activity feed (was oldest-top — days-ago sort inverted), quote…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Latest-first everywhere: activity feed (was oldest-top — days-ago sort inverted), quotes, event captures. Schedules/chats stay chronological by design."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Journey retro sweep repairs BOTH canonical contact fields (flag was skipped when only t…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Journey retro sweep repairs BOTH canonical contact fields (flag was skipped when only the timestamp existed)."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "'Auto Closed' is its own status + category",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Migration 100 widens chats.status with auto_closed (base table) and backfills prior sweep conversions (closed + 'Auto Closed' tag). The 8h sweep now sets auto_closed; ticket + email flow unchanged. Dashboard gets an Auto Closed filter tab with live count, an orange status badge, and proper labelling; server filter + zod validation accept the new status;",
      "default queue views exclude it like closed/archived."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Trial self-expiry sweep: dates are authoritative — over trials auto-move to Trial Expir…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Trial self-expiry sweep: dates are authoritative — over trials auto-move to Trial Expired (extension auto-revert included)."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Gate 1 pushes: exactly two mobile reminders (5m + 1h final), 24h stays flag-only — remi…",
    "tags": [
      "Mobile"
    ],
    "bullets": [
      "Gate 1 pushes: exactly two mobile reminders (5m + 1h final), 24h stays flag-only — reminder, not nag."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "HAL signups: per-lead contact STATE narrative (booked-not-held, no-shows, unrecorded at…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "HAL signups: per-lead contact STATE narrative (booked-not-held, no-shows, unrecorded attendance, attempted) — nuance never flattened."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Journey hierarchy: demo BOOKED (manual or auto-detected) implies discovery call done + …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Journey hierarchy: demo BOOKED (manual or auto-detected) implies discovery call done + canonical contact stamp."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "HAL signups: population = the board's free_trial_signup + onboarded_trial segments — ne…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "HAL signups: population = the board's free_trial_signup + onboarded_trial segments — never disagrees with the board again."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Task Dashboard is the contact source of truth: ticks stamp canonical fields, demo impli…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Task Dashboard is the contact source of truth: ticks stamp canonical fields, demo implies discovery, retro sweep, expired/archived excluded from counts."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "One contact truth: journey discovery tick + mark-contacted stamp the canonical fields; …",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "One contact truth: journey discovery tick + mark-contacted stamp the canonical fields; HAL counts first_contact_at OR discovery flag."
    ]
  },
  {
    "date": "2026-08-25",
    "title": "Dev Board: remove the React port; restore Dev Mode to its blank canvas.",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Starting the Dev Board afresh from a new source. Removes the self-contained packages/dashboard/src/components/dev/board/ tree (~41 files, all scoped under",
      ".wq-devboard) and reverts DevMode.tsx to its pre-board version (blank canvas +",
      "TodoNotebook). Nothing in the support or CRM app is touched: the Dev-Mode notification/ring suppression (item 1), the dev_mode column/migration 063, and all shared services stay exactly as they were. Dashboard tsc --noEmit clean."
    ]
  },
  {
    "date": "2026-08-24",
    "title": "hal_book_meeting: meeting owner never defaults to the connector account — HAL asks ever…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "hal_book_meeting: meeting owner never defaults to the connector account — HAL asks every time (no silent defaults)."
    ]
  },
  {
    "date": "2026-08-24",
    "title": "HAL v1.5: Phase 4 leverage tools (bulk_action w/ enforced dry-run, daily_wrap, set_owne…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "HAL v1.5: Phase 4 leverage tools (bulk_action w/ enforced dry-run, daily_wrap, set_owner, add_tag) — voice write spec complete, 15/15."
    ]
  },
  {
    "date": "2026-08-24",
    "title": "HAL v1.4: Phase 3 quality tools (set_gate / update_value / mark_attendance / log_churn)…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "HAL v1.4: Phase 3 quality tools (set_gate / update_value / mark_attendance / log_churn) — honest engine recompute, fixed churn codes, reschedule tasks."
    ]
  },
  {
    "date": "2026-08-24",
    "title": "HAL v1.3: Phase 2 capture tools (create_lead / create_task / add_contact / book_meeting…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "HAL v1.3: Phase 2 capture tools (create_lead / create_task / add_contact / book_meeting) — dupe check, clash check, phone read-back, identity-map seeding."
    ]
  },
  {
    "date": "2026-08-21",
    "title": "HAL v1.2: Phase 1 voice write actions (add_note / set_stage / log_call) — confirm-befor…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "HAL v1.2: Phase 1 voice write actions (add_note / set_stage / log_call) — confirm-before-write, fuzzy match, idempotency, audit. CRM-only, never WeQuote."
    ]
  },
  {
    "date": "2026-08-21",
    "title": "De-emoji: shared monochrome SVG icon set replaces colour emojis across the CRM chrome; …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "De-emoji: shared monochrome SVG icon set replaces colour emojis across the CRM chrome; email feed bodies drop emoji prefixes."
    ]
  },
  {
    "date": "2026-08-21",
    "title": "De-emoji: shared monochrome SVG icon set replaces colour emojis across the CRM chrome; …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "De-emoji: shared monochrome SVG icon set replaces colour emojis across the CRM chrome; email feed bodies drop emoji prefixes."
    ]
  },
  {
    "date": "2026-08-21",
    "title": "UI batch 5: lane logs outcomes without a queue entry (399 endpoint); qual dialog scroll…",
    "tags": [
      "Support"
    ],
    "bullets": [
      "UI batch 5: lane logs outcomes without a queue entry (399 endpoint); qual dialog scroll; 3 more house SearchInputs."
    ]
  },
  {
    "date": "2026-08-21",
    "title": "Email feed entries: type email_in/email_out (feed-known) instead of unknown 'email' (F2).",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Email feed entries: type email_in/email_out (feed-known) instead of unknown 'email' (F2)."
    ]
  },
  {
    "date": "2026-08-20",
    "title": "call-outcome: wq_crm_call_queue has no created_at — drop the orderBy (500 fix).",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "call-outcome: wq_crm_call_queue has no created_at — drop the orderBy (500 fix)."
    ]
  },
  {
    "date": "2026-08-20",
    "title": "Lead-level call-outcome endpoint (queue-aware) for mobile's Log outcome button + post-c…",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Mobile doc 13 (incl. popup trigger + keyboard-avoidance fixes)."
    ]
  },
  {
    "date": "2026-08-20",
    "title": "Emails tab v2: sticky filter bar, sender/direction/attachment filters, content search w…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Emails tab v2: sticky filter bar, sender/direction/attachment filters, content search with highlighting, sort + pagination."
    ]
  },
  {
    "date": "2026-08-20",
    "title": "Priority lane: mark-contacted endpoint + nurture/disqualified excluded from the lane.",
    "tags": [
      "Mobile"
    ],
    "bullets": [
      "Serves the mobile swipe actions (mobile doc 12)."
    ]
  },
  {
    "date": "2026-08-20",
    "title": "Board: global search bar — filters every kanban column live (company/contact).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Board: global search bar — filters every kanban column live (company/contact)."
    ]
  },
  {
    "date": "2026-08-20",
    "title": "Customer sync: win-back revival (cancelled + live + billing → live) and card_removed bu…",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "Fixes web/mobile stage mismatch — revival no longer depends on unretried",
      "WeQuote webhooks. Mobile doc 10 (no mobile changes)."
    ]
  },
  {
    "date": "2026-08-20",
    "title": "Overnight perf pass: batch journey evidence, bulk identity seed, batched Gmail backfill…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "No behaviour change. Full audit in docs/PERF-AUDIT-19AUG.md."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Activities: (type,occurred_at)+(deal_id,occurred_at) indexes; unresponsive sweep overla…",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "The sweep's grouped count full-scanned the feed (>1h), re-fired each restart and stacked, starving the DB. Migration 099."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Migration 098: text(col,'mediumtext') — installed knex typings lack .mediumtext(); comp…",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Migration 098: text(col,'mediumtext') — installed knex typings lack .mediumtext(); compile-only."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Email sync: seed identity map from wq_crm_contacts (deals have no email column).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Email sync: seed identity map from wq_crm_contacts (deals have no email column)."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Email sync: graceful not-configured response + AppError statuses (no more bare 500).",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "Email sync: graceful not-configured response + AppError statuses (no more bare 500)."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "CRM per-user Gmail sync (read side) + Emails tab mini-inbox.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Per-user OAuth with hd=wetech.cloud guard, two-stage fetch, matching engine with review queue and learn step, feed entries, bounded backfill, polling + optional Pub/Sub. Migration 098. Replaces the old Brevo mock tab."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "CRM per-user Gmail sync (read side) + Emails tab mini-inbox.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "Per-user OAuth with hd=wetech.cloud guard, two-stage fetch, matching engine with review queue and learn step, feed entries, bounded backfill, polling + optional Pub/Sub. Migration 098. Replaces the old Brevo mock tab."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Intake checklist per lead + explicit Begin Set-up; dock ages off ended items.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Any-order checklist cards (done items shown), Ready to Start Set Up state, beginSetup endpoint (guarded on open items) replaces auto-advance; lead card mirrors it. Calls dock today-view hides items ended >1h ago."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Task Dashboard v4: three-column journey (Pre-Demo / Demo-Setup / Post Trial Chase).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Fixed checklists with gate-item advancement, per-card note + popup, signup time pill, 5m/1h speed-to-contact timer cleared by discovery call or held meeting (Meet attendance), evidence auto-ticks, 15-min sweep, full trial-lead backfill, journey card on the lead sidebar. Migration 097."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Task Dashboard v4: three-column journey (Pre-Demo / Demo-Setup / Post Trial Chase).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Fixed checklists with gate-item advancement, per-card note + popup, signup time pill, 5m/1h speed-to-contact timer cleared by discovery call or held meeting (Meet attendance), evidence auto-ticks, 15-min sweep, full trial-lead backfill, journey card on the lead sidebar. Migration 097."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Intake checklist per lead + explicit Begin Set-up; dock ages off ended items.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Any-order checklist cards (done items shown), Ready to Start Set Up state, beginSetup endpoint (guarded on open items) replaces auto-advance; lead card mirrors it. Calls dock today-view hides items ended >1h ago."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Intake checklist per lead + explicit Begin Set-up; dock ages off ended items.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Any-order checklist cards (done items shown), Ready to Start Set Up state, beginSetup endpoint (guarded on open items) replaces auto-advance; lead card mirrors it. Calls dock today-view hides items ended >1h ago."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Intake checklist per lead + explicit Begin Set-up; dock ages off ended items.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Any-order checklist cards (done items shown), Ready to Start Set Up state, beginSetup endpoint (guarded on open items) replaces auto-advance; lead card mirrors it. Calls dock today-view hides items ended >1h ago."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Intake checklist per lead + explicit Begin Set-up; dock ages off ended items.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Any-order checklist cards (done items shown), Ready to Start Set Up state, beginSetup endpoint (guarded on open items) replaces auto-advance; lead card mirrors it. Calls dock today-view hides items ended >1h ago."
    ]
  },
  {
    "date": "2026-08-19",
    "title": "Booking notes: 12 retries, 30-day window, per-attachment fallback.",
    "tags": [
      "AI"
    ],
    "bullets": [
      "Gemini docs attach late (old 4-attempt cap stranded meetings) and the old 7d window skipped pre-feature history; the puller now tries every Docs attachment and skips recordings. Stuck rows reset in-deploy for backfill."
    ]
  },
  {
    "date": "2026-08-18",
    "title": "Pipeline v3: lead-level marking + structured set-up completion.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "DealPipeline.tsx (shared card/modal/SVG icons) on the lead sidebar and the",
      "Task Dashboard; completeSetupStep enforces note + quote/invoice link and sequential order, evidence in setup_log (096) + feed; dashboard rows get per-kind actions and proper icons."
    ]
  },
  {
    "date": "2026-08-18",
    "title": "Task Dashboard v2: first in nav, two-column split, mid-funnel backfill.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "backfillIntake seeds call/WhatsApp/demo tasks for active trials missing them and enters onboarding/live deals into the Set Up pipeline; the sweep now fast-forwards multi-step evidence in one pass."
    ]
  },
  {
    "date": "2026-08-18",
    "title": "Task Dashboard: signup intake tasks + sequential Set Up pipeline.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "intake.ts: existing-vs-new intake tasks on applyTrial, auto-completed by connected calls / WA links / bookings; intake completion stamps a fact summary, moves stage to setup_needed (new stage) and starts the pipeline onboarding->first_quote->first_invoice->workhub (30-min sweep, category tasks). New /crm/task-dashboard + /deals/:id/summary + intake endpoints;",
      "Task Dashboard page + sidebar; lead 'What's happening' card. Migration 095."
    ]
  },
  {
    "date": "2026-08-18",
    "title": "Funnel Phase 3: adoption levels 0-5, Gates 6-8, event-ready.",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "adoptionLevels.ts derives levels from usage metrics + module status (level 2 event-only, stated honestly); applyLifecycleEvent handles quote_won/ invoice_raised/accountancy_linked/workhub_adopted into migration-094 stamps;",
      "gates 6-8 clocked from paid_at; analytics adoption strip; hal_adoption tool."
    ]
  },
  {
    "date": "2026-08-18",
    "title": "Funnel Gates 2-5: gate engine, blockers, escalations, funnel views.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "gatesFunnel.ts derives G2-G5 from bookings/attendance/stage-history + new blocker fields (093); hourly escalation sweep (Trial Ending / Gate Breach flags, one-shot ledger); analytics gate strip; blocker card on the lead;",
      "HAL gains hal_speed_to_contact + hal_gate_funnel and a fuller daily report.",
      "Phase 3 telemetry ask documented for Robert."
    ]
  },
  {
    "date": "2026-08-18",
    "title": "Funnel Gates 2-5: gate engine, blockers, escalations, funnel views.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "gatesFunnel.ts derives G2-G5 from bookings/attendance/stage-history + new blocker fields (093); hourly escalation sweep (Trial Ending / Gate Breach flags, one-shot ledger); analytics gate strip; blocker card on the lead;",
      "HAL gains hal_speed_to_contact + hal_gate_funnel and a fuller daily report.",
      "Phase 3 telemetry ask documented for Robert."
    ]
  },
  {
    "date": "2026-08-17",
    "title": "Funnel Gate 1: priority lane, instant alerts, live timers, escalation.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "signupFunnel.ts owns the covered-hours clock (Mon-Fri 9-18 London), lane, attempted/connected stamps (queue + booking hooks), 15m/60m/24h ladder and speed-to-contact stats. Instant <60s ping precedes the enriched trial alert.",
      "Web: lane pinned above the Call Queue with ticking colour timers; analytics leads with the speed-to-contact tile. Migration 092; MOBILE-UPDATE-09."
    ]
  },
  {
    "date": "2026-08-17",
    "title": "HAL v1.1: MCP OAuth flow — addable as a Claude connector.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Protected-resource + AS metadata, dynamic client registration (persisted),",
      "PKCE code flow with CRM-agent login (bcryptjs), stateless HMAC access/refresh tokens; static HAL_TOKEN bearer unchanged for the app/API path."
    ]
  },
  {
    "date": "2026-08-17",
    "title": "Migration 091 rev 2: wq_agent_phones table (agents is a VIEW in prod).",
    "tags": [
      "Support"
    ],
    "bullets": [
      "ALTER on the legacy agents view failed ('not BASE TABLE'); phones get their own table and HAL's staff directory joins it. View untouched."
    ]
  },
  {
    "date": "2026-08-17",
    "title": "HAL v1: read-only CEO command-centre MCP server.",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "hal-mcp/ (pm2, :3020, bearer auth, MCP streamable HTTP) over the compiled CRM services: daily report, signups/conversions/churn, call queue, qualified pipeline, board counts, lead search/detail, schedule, staff directory.",
      "Migration 091 agents.phone. Integration contract in docs/HAL-MCP-V1.md."
    ]
  },
  {
    "date": "2026-08-17",
    "title": "Fresh-signup timer badge + daily discovery-call reminders.",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "TrialDiscoveryBadge (board + leads, mobile mirrors via trialStartedAt/ discoveryCallDone on mapDeal); discoveryReminders sweep pushes to CRM-app devices daily per unresolved lead until spoke/booked/bad_number, no_answer/ callback keep it going. Migration 090; MOBILE-UPDATE-08."
    ]
  },
  {
    "date": "2026-08-14",
    "title": "per-message agent attribution on agent-side bubbles",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Every agent message shows its sender's profile icon (avatar or initial) + name on the right; grouping breaks on sender change so multi-agent handovers read message-by-message. Own sends attributed instantly from the logged-in profile."
    ]
  },
  {
    "date": "2026-08-14",
    "title": "distinct pickup ding (web+mobile) + multi-agent chat header",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Pickup: on assign, other agents get the Correct Ding on web (+ toast naming the picker; mute-aware; never for own pickups) and an audible mobile push (soundKey pickup_sound -> pickup_wequote.wav once the app bundles it;",
      "EXPO_PUSH_PICKUP_SOUND / EXPO_PUSH_PICKUP_CHANNEL_ID overridable) after the silent ring-dismiss. Header: profile icon + name chip for every agent who has answered in the chat (unique senders from history + live messages, avatars mapped through both paths), beside the assigned-agent chip."
    ]
  },
  {
    "date": "2026-08-14",
    "title": "Trial alerts: exactly-once delivery + missed-alert sweep.",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "trial_alert_sent_at (migration 089) stamped on real WhatsApp delivery;",
      "10-minute sweep re-sends unstamped trials from the last 3 days — covers sync-created signups (no webhook) and restart-killed delayed sends."
    ]
  },
  {
    "date": "2026-08-14",
    "title": "voice typing in the composer (browser speech recognition)",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Mic toggle in the chat composer toolbar: press to talk (live as-you-speak transcription via the Web Speech API, auto-restarting through Chrome's silence timeouts), press again to stop; the transcript is a normal editable draft sent like any message. Existing text is preserved and appended to; mic stops on send/unmount; clear error on blocked mic permission; button hidden where the API is unavailable. Mobile app keeps the iPhone keyboard's native dictation (per Lee)."
    ]
  },
  {
    "date": "2026-08-12",
    "title": "Meeting attendance: auto Held/No-Show via Meet participant records.",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "attendance.ts sweeps held meetings (start+2h) through the Meet REST API v2 impersonating the host — only-WeTech-joined => no_show, external/anonymous/ phone => held; conservative classification; manual chip on the Meetings tab always wins. Migration 087; scope request doc for Robert."
    ]
  },
  {
    "date": "2026-08-12",
    "title": "Meeting attendance: auto Held/No-Show via Meet participant records.",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "attendance.ts sweeps held meetings (start+2h) through the Meet REST API v2 impersonating the host — only-WeTech-joined => no_show, external/anonymous/ phone => held; conservative classification; manual chip on the Meetings tab always wins. Migration 087; scope request doc for Robert."
    ]
  },
  {
    "date": "2026-08-12",
    "title": "Meeting attendance: auto Held/No-Show via Meet participant records.",
    "tags": [
      "Platform-wide"
    ],
    "bullets": [
      "attendance.ts sweeps held meetings (start+2h) through the Meet REST API v2 impersonating the host — only-WeTech-joined => no_show, external/anonymous/ phone => held; conservative classification; manual chip on the Meetings tab always wins. Migration 087; scope request doc for Robert."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "visibility-based away gate + temporary away-reply card",
    "tags": [
      "Support"
    ],
    "bullets": [
      "hasFocus() made the away ring fire while the tab was visible but the window unfocused (side-by-side windows / DevTools) — the gate is now document.visibilityState only: visible = silent. The away alert drops the",
      "Accept/Decline pickup card for a compact temporary card (click to open) that clears on returning to the tab, replying from another device, or the chat closing."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "Gemini notes for CRM bookings — private to the recorder.",
    "tags": [
      "CRM",
      "AI"
    ],
    "bullets": [
      "bookingNotes.ts: direct google_event_id pull trying host then internal attendees; doc OWNER = recorder = sole viewer (server-enforced via",
      "GET /crm/bookings/:id/notes); Meetings tab shows content to the owner and a locked line to everyone else. Migration 086; 15-min sweep."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "Resend signup alert from trial/onboarding cards.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "sendTrialWhatsapp extracted (auto alert + manual re-fire share it);",
      "POST /crm/deals/:id/resend-trial-alert logs who re-sent; megaphone button on variant-trial board cards with DM/group toast."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "Trial alerts: wait for enrichment, parse notes for alias/type/heard.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "2-min send delay (TRIAL_ALERT_DELAY_SECONDS) so the onboarding events land before the message formats; alias falls back to the WeQuote Link in notes;",
      "Company Type / how-heard parsed from the Onboarding Answers block; contact falls back to meta.contact."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "Trial alerts: wait for enrichment, parse notes for alias/type/heard.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "2-min send delay (TRIAL_ALERT_DELAY_SECONDS) so the onboarding events land before the message formats; alias falls back to the WeQuote Link in notes;",
      "Company Type / how-heard parsed from the Onboarding Answers block; contact falls back to meta.contact."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "New-trial alerts: mobile push + WhatsApp on every real-time signup.",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "trialAlerts.notifyNewTrial fired from both applyTrial branches (first trial start only): Expo push to active agents + WhatsApp from the connected number to TRIAL_ALERT_WHATSAPP (default 447758958494). Best-effort, non-blocking."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "New-trial alerts: mobile push + WhatsApp on every real-time signup.",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "trialAlerts.notifyNewTrial fired from both applyTrial branches (first trial start only): Expo push to active agents + WhatsApp from the connected number to TRIAL_ALERT_WHATSAPP (default 447758958494). Best-effort, non-blocking."
    ]
  },
  {
    "date": "2026-08-11",
    "title": "New-trial alerts: mobile push + WhatsApp on every real-time signup.",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "trialAlerts.notifyNewTrial fired from both applyTrial branches (first trial start only): Expo push to active agents + WhatsApp from the connected number to TRIAL_ALERT_WHATSAPP (default 447758958494). Best-effort, non-blocking."
    ]
  },
  {
    "date": "2026-08-10",
    "title": "attention ring only when genuinely away from the tab",
    "tags": [
      "CRM",
      "Support"
    ],
    "bullets": [
      "The away-reply ring fired for every customer reply while the agent was on the dashboard (just not on that chat's screen). Gate is now tab-level:",
      "focused+visible = no ring (inbox + active-chat tone cover it); hidden or unfocused = ring. Returning to the tab clears attention rings; transfer rings persist until opened."
    ]
  },
  {
    "date": "2026-08-10",
    "title": "Leads page: Disqualified tab.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "One pill isolating every disqualified lead (qualification status, any stage), count badge included. Board intentionally unchanged."
    ]
  },
  {
    "date": "2026-08-10",
    "title": "Board: collapsible columns with padded count pills.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Chevron top-right on every kanban column; collapsed = slim strip (chevron, outlined count pill, vertical label), click to expand. Remembered per column in localStorage (wq_board_collapsed)."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "self-updating release notes — one entry per commit, on every build",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "The dashboard build runs scripts/generate-updates.cjs: every commit since the curated boundary becomes a release-note entry (subject -> title, body",
      "> bullets, tags inferred, deploy boilerplate stripped). Every deploy runs the build on the server, so the Platform Updates page refreshes itself with each push. Curated Apr-Aug history unchanged; generated entries merge on top. Fail-open when git is unavailable."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "stop the timer on notice conversion; chat-scoped timer anchor",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "The finish-notice button (and any notice conversion) now freezes the widget timer (isActive gates on noticeLocked) and finish-notice ends the server session. Anchor bug fixed: the quota endpoint anchored the timer to the newest active chat for the SHARED customer_id, so a stale/other visitor's chat could show hours on a fresh conversation — the widget now passes ?chat_id and the server anchors only to that chat (converted/closed chats return no anchor; legacy widgets keep old behaviour)."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "'Send request & close chat' button on the banner",
    "tags": [
      "Support"
    ],
    "bullets": [
      "Visitors who finish early (1-2 of their 3 messages) can convert the chat to a ticket immediately from the banner. New customer-authed",
      "POST /chats/:id/finish-notice runs the same idempotent runNoticeHoursFlow as the 3rd-message / 2-minute paths (guards: active notice, unconverted,",
      ">=1 visitor message). Banner shows the explainer + button once >=1 message is sent; locks on success."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "3 visitor messages before ticket + explicit allowance copy + taller widget",
    "tags": [
      "Support",
      "Widget"
    ],
    "bullets": [
      "Conversion now triggers on the 3rd visitor message (was the 1st;",
      "NOTICE_MAX_VISITOR_MESSAGES env-tunable) OR at the 2-minute mark with whatever was sent (sweep-enforced), keeping the 30s empty-chat rule.",
      "Widget: banner states the 3-message allowance with a live remaining counter, locks on the 3rd send, and asks the launcher to grow the window (WQ_NOTICE_MODE -> min(640px, viewport)) while a notice is active."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "Qualification panel: estimated deal value is a direct input.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Writes deals.amount (single value everywhere); server recomputes the budget gate on save so >= 1800 qualifies immediately. Fixes leads stuck at Working with no way to enter the value from the panel."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "Unqualified call pool + forced post-call qualification.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Queue trigger 'unqualified': read-time sync of all not-yet-qualified pre-trial leads (once each), sweep drops them on qualify/nurture/progress; items carry event + qualification badge; All/By-Event views; spoke/booked forces the qualification modal until complete and auto-ticks the Engagement gate from any queue trigger. Mobile contract in MOBILE-UPDATE-06."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "Lead Qualification Phase 6: the §12 acceptance criteria as a Jest suite.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "19 tests over the engine: hard fails, Working states, value floor, single qualified_at stamp, reason-code guard rails, hold/reopen cycle, grade-vs-gate separation, §6 scoring bands. Closes PRD v1.0."
    ]
  },
  {
    "date": "2026-08-07",
    "title": "Lead Qualification Phase 5: unresponsive sweep (PRD §7).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "8+ outbound attempts in 21 days with no two-way engagement moves a worked lead to Nurture (reason no_engagement) via the same hold the panel uses. Daily job (QUAL_SWEEP_HOURS), grouped feed query, feed entry per move, Reopen un-does."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Lead Qualification Phase 4: raw qualified pipeline on Analytics (PRD §11).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "pipelineReport gains a qualified block (gross of qualified open deals, grade mix, status funnel ANL→Working→Qualified→Demo, weighted:null until Fi's probability). Emerald hero card on Analytics; PRD-03 weighted bands untouched."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Archive self-heal: shows can't bury customers; going live unarchives.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "archiveGroup(withLeads) now skips live/paying/WeQuote-account deals (feed entry notes it); moveStage to successfully_signed_up clears archived_at automatically.",
      "Root cause of PAI Group vanishing: ISE 2026 show archive swallowed the matched existing deal, which then went live while archived."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Unarchive from the lead pop-up: ARCHIVED badge + restore button.",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "mapDeal exposes archivedAt; DealDetail header swaps Archive for Unarchive on archived leads (uses the existing /crm/deals/:id/restore)."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Lead Qualification Phase 3: A/B/C priority scoring (PRD §6).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "computeScore with the PRD weights on deterministic sub-scales; stored for qualified leads only (cleared otherwise), refreshed on panel saves, amount edits and meeting bookings. Grade ranks the pipeline and never gates it."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Lead Qualification Phase 2: three-pillar panel, Qualified/Nurture board columns.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "DealQualification.tsx replaces the old Qual checklist (compact sidebar card + overlay editor; server-computed status, reason-code dialog on demoting edits).",
      "segmentOfDeal + web columnForDeal gain qualified/nurture with agreed precedence (terminal > nurture > qualified, demo pull-in wins, lifecycle after trial).",
      "Leads page: qualification chip column + filter."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "ring the assigned agent on customer replies while away",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "New agent-room event assigned_chat_message on both customer send paths.",
      "Dashboard: additive attention ring (same mechanism as the transfer ring) when the tab is backgrounded/unfocused or on another screen — rings until the chat is opened; cleared on open/close/decline or when the agent's own reply arrives from another device. Actively-viewing agents hear only the existing short tone. Mobile: pushService.isAgentConnected() picks the 20s ringtone when the agent has NO live socket at all (browser + app closed), else the normal ding."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Lead Qualification Phase 1: migration 084 + deterministic gate engine.",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "PRD v1.0 (Fi): six must-have gates across ICP/BANT/Engagement compute qualification_status server-side (not_qualified/working/qualified/disqualified/ nurture + manual holds with mandatory reason codes). Thresholds: amount >= 1800",
      "ARR, quote volume > 5000/mo, 10+ staff, <=6mo timeline. Engagement auto-ticks from completed logged calls/meetings. GET/PATCH /crm/deals/:id/qualification."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "WhatsApp chat: newest-first message pages, real reactions, real send ids.",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Messages endpoint returned the OLDEST page so busy groups lost new messages on refresh (LCR went back to 11 June) — now newest N, offset pages backwards. Gateway forwards reactionMessage as message.reaction (skips junk rows + protocolMessage);",
      "webhook attaches emoji to the original row's metadata.reactions and emits whatsapp_group_reaction; both chat UIs render chips live. Portal sends stored under the real gateway messageId so reactions/replies to them match."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Lead WhatsApp tab: chat with the linked live group from the CRM.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "DealWhatsApp.tsx reuses the support Groups endpoints (messages/send/star/pictures, socket + polling) against deal.whatsapp_group_jid — same link Conversation History uses. Sends text/image/video/document and MediaRecorder voice notes (new ptt passthrough on the group send route → gateway delivers a real voice note). New",
      "GET /crm/deals/:id/wa-group returns the linked jid+name."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Live companies stay in All Live even with a booked meeting.",
    "tags": [
      "CRM",
      "Mobile"
    ],
    "bullets": [
      "A meeting with an existing customer is not a demo: the booked-demo pull-in no longer applies to successfully_signed_up in segmentOfDeal (server, feeds mobile too) and columnForDeal (web board). Trial-expired stages keep the pull-in."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "WA summaries read the gateway's real history endpoint (/chats/:jid/messages).",
    "tags": [
      "Support"
    ],
    "bullets": [
      "The Baileys gateway lacks the legacy /sessions/:id/messages route; direct fetch with x-api-key against the SQLite-backed chats endpoint, from_me→US, caption fallback."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Conversation History tab: support + WhatsApp Claude summaries, feature requests.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Migration 082 (WA group link, summary cache, wq_crm_feature_requests). Platform-only latest-first bullet summaries via claudeService; WA picker with 2-month backfill;",
      "feature-request ledger ready for Support-side forwarding (same table)."
    ]
  },
  {
    "date": "2026-08-06",
    "title": "Conversation History tab: support + WhatsApp Claude summaries, feature requests.",
    "tags": [
      "CRM",
      "Support",
      "Mobile"
    ],
    "bullets": [
      "Migration 082 (WA group link, summary cache, wq_crm_feature_requests). Platform-only latest-first bullet summaries via claudeService; WA picker with 2-month backfill;",
      "feature-request ledger ready for Support-side forwarding (same table)."
    ]
  },
  {
    "date": "2026-08-05",
    "title": "auto-close open chats after 8h inactivity -> Auto Closed ticket",
    "tags": [
      "Support",
      "Mobile"
    ],
    "bullets": [
      "A background sweep (5-min tick, DB-clock keyed, conditional UPDATE that re-checks the inactivity window so a fresh message aborts the close) closes every open chat whose last message is 8+ hours old and converts it to a ticket via createTicketFromChat(source='auto_closed'; migration 082 widens the tickets.source enum). The chat gets tags ['Auto Closed', 'Auto Closed",
      "On <date>'] (tags[0] renders as the resolution tag) + a transcript system line written before the ticket snapshot; the ticket gets an explanatory event. chat_closed + queue_update emitted; no rings/pushes.",
      "CHAT_AUTO_CLOSE_HOURS env-overridable; 0 disables."
    ]
  },
  {
    "date": "2026-08-05",
    "title": "Mobile docs sync (master spec + updates).",
    "tags": [
      "Mobile"
    ],
    "bullets": [
      "Mobile docs sync (master spec + updates)."
    ]
  },
  {
    "date": "2026-08-05",
    "title": "Pipeline report: auto_new_lead with a booked upcoming demo counts under demo_scheduled …",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Pipeline report: auto_new_lead with a booked upcoming demo counts under demo_scheduled (report-time reclassification)."
    ]
  },
  {
    "date": "2026-08-03",
    "title": "WeQuote org users: sync + webhooks + Users/Contacts tab (Robert's feed).",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "Migration 081; hourly full-list sync with guarded removal; user_* events; per-lead live refresh endpoint; Users/Contacts table with Book-meeting per user; users flow into the attendee type-ahead and meeting correlation as contacts."
    ]
  },
  {
    "date": "2026-08-03",
    "title": "granular day-by-day release notes",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "One entry per shipping day (Apr 2026 -> today, 50 dated entries; days spanning CRM + Support split in two), every user-facing change as its own bullet incl. same-day fix chains and critical incidents. Replaces the summarised entries."
    ]
  },
  {
    "date": "2026-08-03",
    "title": "Platform Updates release-notes page",
    "tags": [
      "CRM"
    ],
    "bullets": [
      "New sidebar item directly under Dashboard (above Support/CRM groups) at",
      "/updates, in the WeQuote updates-page format: quarter filter, entries with date + title + area tags left and bullet details right. Curated from the full deploy history (Apr 2026 -> today), newest first. Each entry has an optional screenshot slot (public/updates/<file>.png via updatesData.ts)."
    ]
  }
]
